import { createStore } from "vuex";

function isMatchFilter(product, filter) {
	if (filter.title) {
		if (!product.title.toLowerCase().includes(filter.title.toLowerCase())) return false
	}
	return true
}

export default createStore({
	state: {
		prices: 44,
		guarantee:
		{
			picture1: require('@/assets/Cert-1.jpg'),
			picture2: require('@/assets/Cert-2.jpg'),
			picture3: require('@/assets/Cert-3.jpg'),
			picture4: require('@/assets/Cert-4.jpg'),
			picture5: require('@/assets/Cert-5.jpg'),
			picture6: require('@/assets/Cert-6.jpg'),
			picture7: require('@/assets/Cert-7.jpg'),
			picture8: require('@/assets/Cert-8.jpg'),
			picture9: require('@/assets/sert-1.jpg'),
			picture10: require('@/assets/sert-3.jpg'),
			picture11: require('@/assets/sert-4.jpg'),
			picture12: require('@/assets/c1.jpg'),
			picture13: require('@/assets/c2.jpg'),
			picture14: require('@/assets/c3.jpg'),
			picture15: require('@/assets/c4.jpg'),
			picture16: require('@/assets/c5.jpg'),
			picture17: require('@/assets/c6.jpg'),
			picture29: require('@/assets/c7.jpg'),
			picture18: require('@/assets/c8.jpg'),
			picture19: require('@/assets/c9.jpg'),
			picture20: require('@/assets/c10.jpg'),
			picture21: require('@/assets/c11.jpg'),
			picture22: require('@/assets/c12.jpg'),
			picture23: require('@/assets/c13.jpg'),
			picture24: require('@/assets/c14.jpg'),
			picture25: require('@/assets/c15.jpg'),
			picture26: require('@/assets/c16.jpg'),
			picture27: require('@/assets/c17.jpg'),
			picture28: require('@/assets/c18.jpg'),
		},
		productsList: [
			{
				id: 1,
				qty: 1,
				name: 'Now Foods, Країна виробник: США',
				title: 'Tea Tree Oil (Масло чайного дерева) 30 мл',
				composition:
				{
					title: 'Склад:',
					name1: '100% pure tea tree oil (масло чайного дерева 100% очищення)',
					quantity: '30 мл',
					dp: '',
					text1: 'Увага! Дозування залежить від особливостей організму людини, необхідно враховувати індивідуальну чутливість, починаючи зі зменшених дозувань.',
					text2: 'Залишає плями на одязі.',
				},
				properties: ['потужний прирородний антибактеріальний, антипаразитарний, противірусний засіб;',
					'має широкий спектр дії - антисептик, інсектицид та репелент, дезінфіктант (для предметів побуту та приміщень);',
					'оказує ранозагоюючу, болепоглинаючу та протиопікову дію;',
					'стимулює імунітет;',
					'пригнічує рост стафілококів, стрептококів, пневмококів, гонококів, кишкової палочки, грибкової флори;',
					'застосовується як дезінфікуючий засіб при саднах, поверхових ранах та потертостях;',
					'широко застосовується у стоматології, косметології та входить до складу компонентів аромотерапії;',
					'входить до складу багатьох сучасних парфумово-косметичних засобів, застосовується у побутовій хімії, в харчовій та хімічній промисловості та для догляду за хатніми тваринами;',
					'антисептична активність масла чайного дерева в присутності крові, гною та ін. речовин природного походження зростає на 10-20%.'
				],
				application: ['різноманітні захворювання шкіри та слизкових оболонок;',
					'вірусні інфекційні захворювання;',
					'ЛОР-захворювання;',
					'герпес;',
					'стоматити, гігнгівіти, пародонтит, карієс, пародонтоз, кровоточивість ясен, зубний біль;',
					'інфекції сечостатевих органів;',
					'запалювальні захворювання жіночих статевих органів;',
					'проблеми шкіри: тріщини, зудіння, попрілості, лупа, підвищене потовиділення, укуси комах опіки отруйними рослинами;',
					'захворювання шкіри: акне, бородавки, фурункули, карбункули, вугри, виразки, рани, абсцеси, дерматити, себорея;',
					'очищення, дезінфекція та дезодорація повітря;',
					'педикульоз;',
					'загальна релаксація та заспокоєння, масаж;',
					'догляд за малюками: скоринки на голові, інфекція в ухах, прання пелюшок та ін.',
				],
				price: 8.76,
				ways: [{ one: 'місцево на неушкоджену поверхню,', two: 'декілька краплин нерозведенного масла;' },
				{ one: 'на ушкоджену поверхню', two: '- компрес: просочити марлю наступним розчином: на 1 ст. л. рослинної олії, попередньо прогрітої на водяній бані, 1-2 краплини масла чайного дерева;' },
				{ one: 'для промивання опіків 2-3 ступеня та гнійних ран', two: '- 40% водяний розчин масла чайного дерева;' },
				{ one: 'при дерматитах, псоріазі, екземі, сипу', two: '- розчин з 1 частини масла чайного дерева та 10 частин іншого косметичного масла, можливо застосування мила, яке містить масло чайного дерева;' },
				{ one: 'оперізуючий лишай', two: '- розчин з 1 частини масла чайного дерева та 10 частин іншого косметичного масла прогріти та наносити на хворобливу зону 2-3 рази на день;' },
				{ one: 'синці, пухирі', two: '- змочений маслом чайного дерева тампон покласти на уражену поверхню та закріпити пластирем 2 рази на день;' },
				{ one: 'трофічні виразки', two: '- застосовувати безпосередньо на виразки 2-3 рази на день;' },
				{ one: 'опіки', two: '- обробити протягом 1-2 хвилин холодною водою та нанести декілька крапель масла чайного дерева на місце опіку 2 рази на день;' },
				{ one: 'грибкові ураження шкіри та нігтів ніг', two: '- чисте масло чайного дерева 2-4 рази на день, та обробка взуття з розпилювача;' },
				{ one: 'для очищення шкіри', two: '- 1-2 краплини масла чайного дерева в разова порцію крему або лосьону;' },
				{ one: 'для очищення волосся, волосяних фолікул, усування лупи', two: '- додати масло до шампуню;' },
				{ one: 'укуси комах', two: '- змішати у пропорції 1:5 масло чайного дерева та рослинну олію та втирати у місце укусу;' },
				{ one: 'опік отруйною рослиною', two: '- втирати суміш у пропорції 1:1 масла чайного дерева та рослинної олії;' },
				{ one: 'кліщи', two: '- декілька крапель масла на місце розташування кліщу на декілька хвилин, та потім вилучити кліща пінцетом та змастити місто укусу для дезінфекції;' },
				{ one: 'мозолі', two: '- 5 крапель масла у ванну для ніг та змастити після ванни;' },
				{ one: 'ЛОР та бронхо-легеневі захворювання', two: '- полоскання: 5 краплин масла на 200 мл води, інгаляції: 10 краплин масла на 100 мл теплої води або 1-2 краплини до інгалятору протягом 3-10 хвилин, компрес: 3-5 краплин чистого масла, можливо втирання у шкіру у зоні носу, грудної клітини, між лопатками;' },
				{ one: 'застуда, герпес, тріщини на губах', two: '- заварювати на стакан води 3 краплини масла чайного дерева, змочити тампон та обробляти двічі на день;' },
				{ one: 'емфізема легень', two: '- інгаляції с додаванням 3-5 крапель масла, розтерти груди та покласти грілку на 1-2 години;' },
				{ one: 'бородавки', two: '- на розпарену бородавку наносити 3-5 краплин масла, доки вона не відпаде;' },
				{ one: 'біль в ухах', two: '- суміш масла чайного дерева з оливковою олією у пропорції 1:2 підігріти та закапавути 1-2 краплини до уха, повторювати за необхідності;' },
				{ one: 'ячмінь', two: '- 2-3 краплини масла на 200 мл теплої води та тримати обличчя над парою протягом 5 хвилин;' },
				{ one: 'профілактика карієсу, відбілювання зубів, укріплення ясен, гінгівіт, кровоточивість ясен', two: '- капати по 1-2 краплини масла зверху зубної пасти та полоскати ротову порожнину 3 рази на день стаканом води з 5 краплинами масла чайного дерева;' },
				{ one: 'зубний біль', two: '- полоскати ротову порожнину водою з маслом та застосовувати тампон з розчином;' },
				{ one: 'профілактика маститу', two: '- обробляти соски маслом після кормлення (не впливає на дитину);' },
				{ one: 'біль у суглобах, травми, розтягування', two: '- втирати у больову ділянку;' },
				{ one: 'вагінальне очищення', two: '- спринцювання розчином 20 краплин масла на 500 мл кип’яченої води, тампони з сумішшю масла чайного дерева с маслом обліпихи та шипшини;' },
				{ one: 'загальна релаксація та заспокоєння, зняття м’язового болю', two: '- 25 краплин масла на ванну;' },
				{ one: 'оброблення шкіри малюка', two: '- масло чайного дерева з маслом вітаміну Е у пропорції 1:10, змити через 5 хвилин;' },
				{ one: 'дезінфекція пелюшок', two: '- після прання залити 4 л води з 20 краплинами масла чайного дерева на ніч.' },
				],
				picture: require('@/assets/tea1.webp'),
				picture2: require('@/assets/tea2.webp'),
			},
			{
				id: 2,
				qty: 1,
				name: 'Now Foods, Країна виробник: США',
				title: 'Келп (Kelp) 150 мкг, 200 таблеток',
				composition:
				{
					title: 'Склад 1 таблетки:',
					name1: 'Iodine (elemental) (from 30 mg Organic Keip) (Whole Plant) (йод (елементарний) (з 30 мг органічної ламінарії) (цільної рослини))',
					quantity: '150 мкг',
					dp: '100',
					text1: 'Інші інгредієнти: целюлозна капсула, стеаринова кислота та стеарат магнію овочевого походження.',
				},
				properties: ['Покращує функцію щитовидної залози;', 'має вплив на скорочувальну здатність сердцевого м’язу;', 'володіє протитромбовою активністю;', 'запобігає розвитку рахіту, остеопорозу, зубного карієсу, ламкості нігтів, волосся;', 'надає загальноукріплюючу дію на організм;', 'покращує обмін речовин;'],
				application: ['захворювання щитовидної залози;',
					'атеросклероз;,',
					'ішемічна хвороба серця;',
					'Базедова хвороба;',
					'програма зниження маси;',
					'захист від впливу радіації;',
					'захворювання кістково-суглобової системи - рахіт, остеопороз;',
					'зубний карієс;',
					'облисіння;',
					'ламкість нігтів, волосся.'
				],
				price: 11.42,
				way: 'по 1 таблетці на день під час їжі. Зберігати у сухому, прохолодному, темному місті.',
				picture: require('@/assets/kelp1.jpg'),
				picture2: require('@/assets/kelp2.jpg'),
			},
			{
				id: 3,
				qty: 1,
				name: 'Now Foods, Країна виробник: США',
				title: 'Omega 3-6-9 (Омега 3-6-9) 100 капсул',
				composition:
				{
					title: 'Склад 2 капсул:',
					space1: true,
					farm: true,
					name1: 'Calories (калорії)',
					name2: 'Total Fat (жири):',
					name3: 'Saturated Fat (насичені жири) ',
					name4: 'Polyunsaturated Fat (поліненасичені жири)',
					name5: 'Monounsaturated Fat (мононенасичені жири)',
					name6: 'Flax Seed Oil (cold pressed, organic)	(масло насіння льону (холодного віджиму, натуральне))',
					name7: 'Evening Primrose Oil  (cold pressed) (seed) (масло примули вечірньої (холодного віджиму) (насіння))',
					name8: 'Canola Oil  (cold pressed, non-GMO) (seed) (масло каноли(холодного віджиму, без ГМО) (насіння))',
					name9: 'Black Currant Oil  (cold pressed) (seed) (масло чорной смородини (холодного віджиму) (насіння))',
					name10: 'Pumpkin Seed Oil (cold pressed) (масло насіння гарбуза (холодного віджиму))',
					quantity: 20,
					quantity2: '2г',
					quantity3: '<0.5г',
					quantity4: '1.5г',
					quantity5: '<0.5г',
					quantity6: '1.4г',
					quantity7: '300мг',
					quantity8: '260мг',
					quantity9: '20мг',
					quantity10: '20г',
					dp: '<0.5г',
					dp1: '3%*',
					dp2: '2%*',
					dp3: '+',
					dp4: '+',
					dp5: '+',
					dp6: '+',
					dp7: '+',
					dp8: '+',
					dp9: '+',
					text1: '*Добова потреба розрахована на дієту у 2000 калорій',
					text2: '+Добова потреба не визначена',
					text3: 'Інші інгредієнти: желатинова капсула.',
				},
				properties: ['Жирні кислоти класу Омега-3:',
					'приймають участь у розвитку та нормальному функціонуванні очей та мозку;',
					'оказують протизапальний ефект;',
					'знижують рівень тригліцеридів у крові;',
					'Жирні кислоти класу Омега-6:',
					'оказують позитивний ефект при алергійних дерматитах та екземі;',
					'знижують сухість шкіри;',
					'підтримують нормальний стан жирових мембран, які оточують клітини шкіри;',
					'Жирні кислоти класу Омега-9:',
					'сприяють підтримці еластичності артерій та шкіри;',
					'оказують онкопротекторну дію.',
				],
				application: ['серцево-судинні захворювання',
					'гіперхолестеринемія;',
					'атеросклероз;',
					'гіпертонічна хвороба;',
					'алергійні захворюпання шкіри;',
					'псоріаз, екзема;',
					'розсіяний склероз;',
					'системний червоний вовчак;',
					'артрити, артрози;',
					'остеохондроз;',
					'фіброзно-кістозна дегенерація;',
					'депресія;',
					'розсіяність, погіршення пам’яті;',
					'сухість слизових оболонок шкіри, ламкість нігтів;',
					'випадіння волосся.',
				],
				price: 13.52,
				way: 'по 2 капсули 1-3 рази на день під час їжі. Зберігати у сухому, прохолодному, темному місті.',
				picture: require('@/assets/omega1.jpg'),
				picture2: require('@/assets/omega2.jpg'),
			},
			{
				id: 4,
				qty: 1,
				name: 'Now Foods, Країна виробник: США',
				title: 'Глюкозамін та хондроїтин з MСM (Glucosamine & Chondroitin with MSM) 90 капсул',
				composition:
				{
					title: 'Склад 3 капсул:',
					name1: 'Calories (калорії)',
					name2: 'Total Carbohydrate (вуглеводи)',
					name3: 'Sodium (натрій)',
					name4: 'Glucosamine Sulfate (from 1500 mg Glucosamine Potassium Sulfate Complex) (глюкозамін сульфат (з 1500 мг комплексу глюкозаміну калієвого сульфату))',
					name5: 'Chondroitin Sodium Sulfate (from Bovine Cartillage) (натрієвий сульфат хондроїтину (з бичачого хрящу))',
					name6: 'MSM (Methylsulfonylmethane) (МСМ (метилсульфонілметан)',
					quantity: 10,
					quantity2: '2г',
					quantity3: '150г',
					quantity4: '1100 мг',
					quantity5: '1200 мг',
					quantity6: '300 мг',
					dp: '',
					dp1: '<1%',
					dp2: '7%',
					dp3: '+',
					dp4: '+',
					dp5: '+',
					text1: '*Добова потреба розрахована на дієту у 2000 калорій',
					text2: '+Добова потреба не визначена',
					text3: 'Інші інгредієнти: целюлозна капсула та стеаринова кислота овочевого походження.',
				},
				properties: ['бере участь у формуванні та покращує трофіку сполучної тканини (зв’язок, сухожиль, кісток, нігтів, серцевих клапанів, шкіри та ін.);',
					'є необхідним для вироблення колагену;',
					'відновлює хрящ;',
					'оказує протибольову дію;',
					'живить рани, ерозії, виразки;',
					'знижує вміст сечової кислоти;',
					'знижує рівень холестерину у крові;',
					'зменшує ризик тромбоутворювання;',
					'запобігає накопиченню атеросклеротичних бляшок на стінках судин, покращує кровообіг;',
					'метилсульфонілметан забезпечує молекулярну структуру білка, входить до складу багатьох амінокислот, приймає участь у синтезі антиоксідантів;',
					'протидіє руйнуванню попереку, знижує біль, запалювання на напругу у суглобах, збільшує їх рухомість, зменшує їх набряклість;',
					'сприяє зростанню переломів.',
				],
				application: ['травми та захворювання кістково-суглобової системи (остеопороз, остеохондроз, переломи, хвороба Бехтерєва, тендовагініти, бурсити, атрити, артрози, ревматоідний поліартрит);',
					'аутоімунні ураження суглобів;',
					'системні захворювання сполучної тканини;',
					'ламкість нігтів, волосся;',
					'алергічні захворювання (харчова алергія, бронхіальна астма);',
					'трофічні виразки;',
					'грибкові захворювання шкіри та слизової оболонки (у т.ч. вагініти);',
					'серцево-судинні захворювання (варикозне розширення вен, пороки серця, атеросклероз);',
					'подагра.',
				],
				price: 22.96,
				way: 'по 3 капсули на день перед або під час їжі. Зберігати у сухому, прохолодному, темному місті.',
				picture: require('@/assets/gluco1.jpg'),
				picture2: require('@/assets/gluco1.jpg'),
			},
			{
				id: 5,
				qty: 1,
				name: 'Now Foods, Країна виробник: США',
				title: 'Omega-3 (Омега-3) 100 капсул',
				composition:
				{
					title: 'Склад 2 капсул:',
					space1: true,
					name1: 'Calories (калорії)',
					name2: 'Total Fat (жири):',
					name3: 'Saturated Fat (насичені жири)',
					name4: 'Polyunsaturated Fat (поліненасичені жири)',
					name5: 'Monounsaturated Fat (мононенасичені жири)',
					name6: 'Fish Oil Concentrate (концентрат риб’ячого жиру)',
					name7: 'Omega-3 Fatty Acids (омега-3 жирні кислоти):',
					name8: 'Eicosapentaenoic Acid (EPA) (ейкозапентаєнова кислота (ЕПК))',
					name9: 'Docosahexaenoic Acid (DHA) (докозагексаєнова кислота (ДГК))',
					quantity: 20,
					quantity2: '2г',
					quantity3: '0.5г',
					quantity4: '1г',
					quantity5: '0.5г',
					quantity6: '2г',
					quantity7: '',
					quantity8: '360 мг',
					quantity9: '240 мг',
					dp: '',
					dp1: '3*',
					dp2: '3*',
					dp3: '+',
					dp4: '+',
					dp5: '+',
					dp6: '',
					dp7: '+',
					dp8: '+',
					text1: '*Добова потреба розрахована на дієту у 2000 калорій',
					text2: '+Добова потреба не визначена',
					text3: 'Інші інгредієнти: желатинова капсула та d-альфатокоферол.',
				},
				properties: ['складається з незамінних жирних кислот:', 'альфа-ліноленова, ейкозапентаєнова кислота (ЕПК), докозагексаєновакислота (ДГК), які є будівельним матеріалом для ейкозаноїдів - гормоноподібних речовин (простогландинів), які сприяють виробленню енергії організмом, збільшують температуру тіла, розширюють або звужують просвіт бронхів;',
					'значно знижує рівень холестеролу, тригліцеридів, зповільнює розвиток атеросклерозу та запобігає тромбоутворенню;',
					'активує імунну систему, нормалізує травлення та жировий обмін;',
					'покращує засвоювання кальцію та магнію клітинами;',
					'прискорює заживлення ран та рубців;',
					'оказує протиалергійну дію;',
					'має онкопретокторну дію;',
				],
				application: ['психоневрологічні захворювання:', 'постінсультні стани, амнезія, хвороба Альцгеймера, порушення пам’яті, мігрень, деменція, розсіяність;',
					'серцево-судинні захворювання (інфаркт, інсульт, гіпертонія);',
					'профілактика атеросклерозу, арітмії, міокардіодисторофії, тромбофлебіту, варикозу, міокардиту, вегето-судинної дистонії;',
					'аутоімунні захворювання:', 'розсіяний склероз, червоний вовчак, ревматоїдний артрит;',
					'остеохондроз, остеопороз;',
					'артрозо-артрит, подагра;',
					'трофічні виразки;',
					'остеомієліт;',
					'простатит;',
					'цукровий діабет;',
					'цироз печінки;',
					'дисфункціональні маточні кровотечі;',
					'ендометріоз;',
					'катаракта, глаукома;',
					'дерматити, екзема, герпес, псоріаз;',
					'профілактика злоякісних новоутворень;',
					'гипотрофії.',
				],
				price: 11.09,
				way: 'по 2 капсули 1-2 рази на день під час їжі. Зберігати у сухому, прохолодному, темному місті.',
				picture: require('@/assets/omega3_1.jpg'),
				picture2: require('@/assets/omega3_2.jpg'),
			},
			{
				id: 6,
				qty: 1,
				name: 'Now Foods, Країна виробник: США',
				title: 'Котячий кіготь (Cat\'s Claw) 500 мг, 100 вегетаріанських капсул',
				composition:
				{
					title: 'Склад 2 капсул:',
					name1: 'Total Carbohydrate (вуглеводи)',
					name2: 'Cat\'s Claw(inner bark)(котячий кіготь(внутрішня частина кори))',
					quantity: '<1 г',
					quantity2: '1 г (1000 мг)',
					dp: '<1%*',
					dp1: '+',
					text1: '*Добова потреба розрахована на дієту у 2000 калорій',
					text2: '+Добова потреба не визначена',
					text3: 'Інші інгредієнти: целюлозна капсула та стеаринова кислота овочевого походження.',
				},
				properties: ['імуномоделююча дія:', 'збільшує продукцію Т-клітин, тимус-залежних лімфоцитів, гранулоцитів та макрофагів;',
					'є потужним прирородним антиоксідантом;',
					'оказує протизапальну та болепоглинаючу дію;',
					'має онкопротекторну дію;',
					'знижує рівень холестерину у крові;',
					'попереджує інтоксікацію, яка пов’язана з дізбактеріозом кишківника;',
					'проявляє антигельмінтну активність;',
					'має антиалергійну та детоксікаційну дію;',
					'покращує кровообіг, укріплює стінки кровоносних судин, знижує артеріальний тиск, запобігає агрегації тромбоцитів;',
					'нормалізує роботу шлунково-кишкового тракту, та покращує перистальтику;',
					'регулює гормональний баланс у випадку мастопатії, порушення менструального циклу, аденоми передміхурової залози, паталогічного клімаксу;',
					'є природним антибіотиком поширеного спектру дії, виявляє протимікробну, антивірусну, протигрибкову активність;',
					'сприяє відновленню ендокринної регуляції (у випадку захворювань щитовидної залози та діабеті).',
				],
				application: ['гострі та хронічні інфекції:', 'ГРВІ, оперізуючий лишай, герпес;',
					'передпухлинні онкологічні захворювання органів у т. ч. мастопатія;',
					'профілактика та лікування захворювань шлунково-кишкового тракту:', 'гастриту, виразки, хвороби Крона, ентероколіту, дізбактеріозу, дивертикульозу, геморою, гельмінтозів;',
					'аутоімунні захворювання, імунодефіцитні стани;',
					'профілактика та лікування захворювань кістково-суглобової системи (атритів, артрозів, бурситів, ревматизму, ревматоідного артриту та ін.);',
					'синдром хронічної втоми.',
				],
				price: 9.94,
				way: 'по 2 капсули 2-3 рази на день під час їжі. Зберігати у сухому, прохолодному, темному місті.',
				picture: require('@/assets/cats1.jpg'),
				picture2: require('@/assets/cats2.jpg'),
			},
			{
				id: 7,
				qty: 1,
				name: 'Now Foods, Країна виробник: США',
				title: 'Lecithin (Лецитин) 1200 мг, 200 гелевих капсул',
				composition:
				{
					title: 'Склад 3 капсул:',
					space2: true,
					name1: 'Calories (калорії)',
					name2: 'Total Fat (жири):',
					name3: 'Saturated Fat (насичені жири)',
					name4: 'Polyunsaturated Fat (поліненасичені жири)',
					name5: 'Soy Lecithin (Non-GMO) (соєвий лецитин (без ГМО)',
					name6: 'Phosphatidyl Choline (фосфатидил холін)',
					quantity: 30,
					quantity2: '2,5г',
					quantity3: '1г',
					quantity4: '2г',
					quantity5: '3,6 г',
					quantity6: '500 мг',
					dp: '',
					dp1: '3*',
					dp2: '5*',
					dp3: '+',
					dp4: '+',
					dp5: '+',
					text1: '*Добова потреба розрахована на дієту у 2000 калорій',
					text2: '+Добова потреба не визначена',
					text3: 'Інші інгредієнти: желатинова капсула та соєва олія без ГМО.',
				},
				properties: ['є основною живильною речовиною для нервів, яка складає 17% переферічної нервової системи та 30% мозку, входить до складу оболонок нервових волокон;',
					'активізує пам’ять, аналітичні функції мислення;',
					'бере участь у нормальному розвитку мозку та нервової системи плоду;',
					'регулює проникність кліткових мембран, бере участь у синтезі білку та у регуляції обміну речовин;',
					'покращує структуру та роботу клітин печінки (гепатоцитів);',
					'знижує рівень холестерину та коцентрацію жирних кислот у крові;',
					'очищує стінки судин від холестеринових бляшок;',
					'усуває розлади, які пов’язані з гормональними процесами в организмі;',
					'гальмує жирову інфільтрацію печінки.',
				],
				application: ['функціональні порушення нервової та психічної деяльності;',
					'розсіяна увага та зниження пам’яті;',
					'хронічна втома, нервове виснаження;',
					'травматичні та інфекціонні захворювання нервової системи;',
					'дегенеративні захворювання нервової системи (енцефалопатії);',
					'неврози, депресія;',
					'розсіяний склероз;',
					'хвороба Альцгеймера;',
					'хронічний алкоголізм, алкогольні поліневрити;',
					'різноманітні фобії;',
					'атеросклероз, гіпертонічна хвороба, стенокардія;',
					'захворювання печінки та жовчовивідної системи (вірусний гепатіт, хронічний гепатіт, дискінезія жовчовиводних шляхів, алкогольні та токсичні гепатіти, жирова дістрофія печінки, цироз печінки);',
					'псоріаз.',
				],
				price: 19,
				way: 'по 1 капсулі 3 рази на день. Зберігати у сухому, прохолодному, темному місті.',
				picture: require('@/assets/lechitin1.jpg'),
				picture2: require('@/assets/lechitin2.jpg'),
			},
			{
				id: 8,
				qty: 1,
				name: 'Now Foods, Країна виробник: США',
				title: 'Full Spectrum Minerals (Повний Комплекс Мінералів) 120 капсул',
				composition:
				{
					title: 'Склад 2 капсул:',
					name1: 'Vitamin D3 (Cholecalciferol) (Вітамін D3 (холекальциферол ))',
					name2: 'Calcium (from Calcium Carbonate (Aquamin® Seaweed Derived Minerals)) (кальцій (кальцію карбонат (Aquamin® мінерали з водоростей))',
					name3: 'Iodine (from Potassium Iodide (йод (калію йодид))',
					name4: 'Magnesium (from Magnesium Oxide, Magnesium Citrate and Aquamin® Seaweed Derived Minerals) (магній (магнію оксид, магнію цитрат та Aquamin®мінерали з водоростей)',
					name5: 'Zinc (fron Zinc Bisglycinate) (TRAАCS™) (цинк (цинку бісгліцинат (TRAАCS™)))',
					name6: 'Selenium (from L-Selenomethionine) (селен (селенметіонін))',
					name7: 'Copper (from Copper Bisglycinate) (TRAАCS™) (мідь (бісгліцинат (TRAАCS™)))',
					name8: 'Manganese (from Manganese Bisglycinate) (TRAАCS™) (марганець (бісгліцинат (TRAАCS™)))',
					name9: 'Chromium (from Chromium Picolinate) (хром (піколінат))',
					name10: 'Molybdenum (from Sodium Molybdate) (молібден (натрію молібдат))',
					name11: 'Potassium (from Potassium Chloride) (калій (хлорид))',
					quantity: '5 мкг (200 МЕ)',
					quantity2: '250 мг',
					quantity3: '112,5 мкг',
					quantity4: '250 мг',
					quantity5: '7,5 мг',
					quantity6: '50 мкг',
					quantity7: '1 мг',
					quantity8: '2,5 мг',
					quantity9: '100 мкг',
					quantity10: '50 мкг',
					quantity11: '50 мг',
					dp: '25',
					dp1: '19',
					dp2: '75',
					dp3: '60',
					dp4: '68',
					dp5: '91',
					dp6: '111',
					dp7: '109',
					dp8: '286',
					dp9: '111',
					dp10: '1',
					text1: '*Добова потреба розрахована на дієту у 2000 калорій',
					text2: '',
					text3: 'Інші інгредієнти: желатинова капсула та рисове борошно та магнію стеарат (овочевого похолження).',
				},
				properties: ['регулює обмін білків, жирів та вуглеводів в организмі;',
					'оптимізує баланс мінералів та вітамінів;',
					'є потужним комплексом антиоксидантів;',
					'регулює базові ферментативні та інші реакції в организмі, запобігає розвитку обмінних, імунодефіцитних та інших захворювань органів та систем;',
					'бере участь у формуванні кісток попереку, зубів, волосся та нігтів;',
					'попереджує вимивання кальцію з кісток, покращує систему згортання крові, стимулює кору наднирників, гальмує вироблення гістаміну;',
					'відновлює нервову діяльність, покращує нервово-м’язову передачу імпульсів;',
					'регулює гормональну діяльність;',
					'покращує антитоксичні функції організму.',

				],
				application: ['порушення формування кісткового попереку;',
					'остеопороз;',
					'перелами кісток;',
					'попередження переламів при остеопорозі;',
					'карієс;',
					'випадіння волосся, ламкість нігтів;',
					'судомний синдром;',
					'геморагічні діатези, анемія;',
					'хронічна кровоточивість ясен;',
					'алергійні захворювання;',
					'бронхіальна астма;',
					'гальмування росту;',
					'стрес;',
					'імунодефіцитні стани;',
					'запобігання процесів старіння;',
					'профілактика злоякісних новоутворень;',
					'захист організму від негативних факторів зовнішньої середи.',
				],
				price: 15.94,
				way: 'по 2 капсули на день під час їжі. Зберігати у сухому, прохолодному, темному місті.',
				picture: require('@/assets/full1.jpg'),
				picture2: require('@/assets/full2.jpg'),
			},
			{
				id: 9,
				qty: 1,
				name: 'Now Foods, Країна виробник: США',
				title: 'Amino Complete (Амінокислотний комплекс) 120 капсул',
				composition:
				{
					title: 'Склад 4 капсул:',
					name1: 'Calories (калорії)',
					name2: 'Protein (білок)',
					name3: 'Вітамін B6',
					name4: 'Blend of peptide-bound Amino Acid sources (Whey protein Isolate, Soy protein Isolate, Sodium Caseinate) plus Amino Acids (L-Glutamine, L-Arginine, l-Ornithine) (сумішпептидно зв’язаних джерел амінокислот (ізолят білку сируватки, ізолят білку сої, казеінат натрію) та амінокислоти ( L-глутамин, L-аргінін, l-орнитин))',
					quantity: 10,
					quantity2: '2г',
					quantity3: '13мг',
					quantity4: '2.8г',
					dp: '*',
					dp1: 4,
					dp2: 765,
					dp3: '+',
					text1: '*Добова потреба розрахована на дієту у 2000 калорій',
					text2: '+Добова потреба не визначена',
					text3: 'Інші інгредієнти: желатинова капсула та стеаринова кислота (овочевого походження), кремнію диоксид.',
				},
				properties: ['Регулює обмін речовин, секреторну функцію шлунку, печінки, підшлункової залози,  кишківнику, бере участь у кровотворенні, має детоксикуючі властивості, регулює апетіт;', 'регулює водний баланс, підтримує необхідний рівень кислотності середовища (РН);', 'захищає мозок від токсинів та шкідливих речовин, які циркулюють у крові (адже амінокислоти долають гематоенцефалітичний бар\'єр);', 'гальмує рост пухлин, корегує імунний статус, прискорюючи вироблення імуноглобулинів та антитіл;', 'нормалізує роботу центральної нервової системи; знижує рівень холестерину у крові та покращує кислородне живлення органів;', 'має позитивний вплив на серцево-судинну систему, розширює судини, знижує аптеріальний тиск, запобігає розвитку атеросклеротичних бляшок;', 'покращує діяльність органів травлення, запобігає утворенню жиру у печінці та артеріях, виводить важкі метали, захищає організм від випромінювання;', 'покращує роботу кістково-суглобової системи сприяючи виробленню колагену, засвоєнню кальцію та нормальному росту кісток у дітей (збільшуючи гормон росту);', 'сприяє нормалізації стану волосся, шкіри, нігтів; має антиоксидантну та протиалергійну дію.'],
				application: ['Захворювання серцево-судинної системи (атеросклероз, ІХС, гіпертонічна хвороба, ожиріння);', 'захворювання шлунково-кишкового тракту; цукровий діабет I та II типу;', 'захворювання печінки та підшлункової залози;', 'захворювання щитовидної залози;', 'профілактика онкозахворювань;', 'імунодефіцити;', 'захворювання центральної та переферичної нервової системи;', 'депресивні стани;', 'розумова затримка розвитку;', 'зниження пам’яті;', 'зниження маси тіла;', 'захворювання кістково-суглобової системи;', 'гіповітамінози;', 'порушення водно-солевого та азотного обміну;', 'період одуження після хирургічних операцій та спортивних травмувань;', 'вірусні герпетичні інфекції;', 'анемії;', 'алергійні захворювання;', 'захворювання шкіри, волосся, нігтів;', 'омолодження організму;', 'відставання у рості та розвитку;', 'алкоголізм та наркоманія;', 'профілактика СНІДу.'],
				price: 17.2,
				way: 'по 4 капсули на день. Зберігати у сухому, прохолодному, темному місті.',
				picture: require('@/assets/AminoComplete.png'),
				picture2: require('@/assets/Amino2.png'),
				picture3: require('@/assets/Amino3.png')
			},
			{
				id: 10,
				qty: 1,
				name: 'Now Foods, Країна виробник: США',
				title: '4x6 Acidophilus (Ацидофілус 4х6) 120 капсул',
				composition:
				{
					title: 'Склад 1 капсули:',
					name1: 'Blend of Probiotic bacteria: (суміш пробіотичних бактерій):',
					name2: 'Lactobacillus acidophilus (La-14)',
					name3: 'Bifidobacterium lactis (BI-04)',
					name4: 'Bifidobacterium longum (BI-05)',
					name5: 'Streptococcus thermophilus (St-21)',
					name6: 'Lactobacillus bulgaricus (Lb-87)',
					name7: 'Lactobacillus paracasei (Lpc-37)',
					quantity: '4 млрд. орг.',
					quantity2: '',
					quantity3: '',
					quantity4: '',
					dp: '*',
					dp1: '',
					dp2: '',
					dp3: '',
					text2: '*Добова потреба не визначена',
					text3: 'Інші інгредієнти: желатинова капсула, мікрокристалічна целюлоза, стеаринова кислота (овочевого походження), кремнію диоксид.',
				},
				properties: ['пригнічує гнильні процеси;',
					'відновлює нормальний вміст мікрофлори в организмі, покращує травлення та засвоювання їжі (зброджування вуглеводів, розчин клітковини, гідроліз білків, омилення жирів);',
					'стимулює перистальтику кишківника, сприяє виведенню токсинів;',
					'продукує молочну кислоту, та натуральні антибіотики, які пригнючують рост шкідливих мікроорганизмів - патогенних бактерій, вірусів, грибків, паразитів;',
					'сінтезує вітаміни В3, В5, В6, В12, фолієву кислоту, біотин, вітамін К та незамінні амінокислоти;',
					'оказує імуностимулюючу дію;',
					'попереджує газоутворення та розлад стулу;',
					'оказує протиалергійну дію;',
					'дезактивує канцерогени;',
					'знижує рівень холестерину;',
					'збільшує резистентність організму до різних несприятливих факторів;',
					'посилює всмоктування кальцію та вітаміну Р.',
				],
				application: ['дізбактеріоз різноманітного генезу;',
					'гострі та хронічні коліти;',
					'хвороба Крона;',
					'закрепи, проноси;',
					'дискінезії жовчних шляхів;',
					'грибкові ураження кишківника, піхви, шкіри;',
					'простатіт;',
					'стоматити, гінгівіти;',
					'цукровий діабет;',
					'непереносимість лактози;',
					'гіперхолестериномія;',
					'гінекологічні запалювальні хвороби;',
					'алергійні захворювання дихальних шляхів, шкіри;',
					'юнацькі вугри;',
					'гіповітамінози;',
					'лікування антибіотиками, аспірином, гормонами;',
					'промінева- та хіміотерапія;',
					'різні види отруєнь;',
					'гострі інфекційні захворювання;',
					'хворим у пре- та післяопераційний період;',
					'программа зниження маси тіла;',
					'особам, які перебувають у зонах з несприятливими екологічними умовами.',
				],
				price: 22.74,
				way: 'по 1 капсулі 1-2 рази на день між прийомами їжі. Протипоказань немає. Зберігати охолодженим з ціллю зберігання високої ефективності.',
				picture: require('@/assets/acidophilus1.webp'),
				picture2: require('@/assets/acidophilus2.webp'),
			},
			{
				id: 11,
				qty: 1,
				name: 'Now Foods, Країна виробник: США',
				title: 'Chromium Picolinate (Хрому піколінат) 200 мкг 100 капсул',
				composition:
				{
					title: 'Склад 1 капсули:',
					name1: 'Chromium (from Chromium Picolinate) (хрому піколінат)',
					quantity: '200 мкг',
					dp: '571',
					text3: 'Інші інгредієнти: рисове борошно та целюлоза (капсула).',
				},
				properties: ['сприяє метаболізму глюкози підчас цукрового діабету I та II типу, знижує потребу в інсуліні та сприяє транспортуванню глюкози до клітин;',
					'прискорює окислення глюкози, стимулює синтез глікогену з глюкози до печінки та м’язів;',
					'усуває гіпоглікемію, стабілізує рівень цукру та інсуліну;',
					'укріплює м’язову систему, сприяє нарощуванню м’язової маси;',
					'регулює жировий обмін, сприяє метаболізму жирів, а також холестерину, зкорочує синтез жирів;',
					'бере участь у багатьох ферментативних реакціях, стимулює обмін речовин, сприяє регуляції маси тіла та позбавлює від зайвої ваги;',
					'знижує апетіт, пригнічує пристрасть до солодощів;',
					'нормалізує діяльність вегетативної, центральної та переферичної нервової системи;',
					'регулює артеріальний тиск при вегето-судинних дистоніях та при гіпертонії;',
					'покращує мінеральний обмін;',
					'запобігає розвитку остеопорозу.',

				],
				application: ['цукровий діабет I та II типу;',
					'гіпоглікемічні стани;',
					'ожиріння;',
					'нарощування кістково-м’язової маси;',
					'профілактика та лікування серцево-судинних захворювань (гіпертонічна хвороба, атеросклероз);',
					'гіпотонія;',
					'вегето-судинна дистонія;',
					'поліневрити, переферичні неврити;',
					'депресія;',
					'порушення психики;',
					'гострі інфекції;',
					'хронічні рани, що не загоюються;',
					'хронічні виразки;',
					'лікування вугрового сипу.',
				],
				price: 7.34,
				way: 'по 1 капсулі на день під час їжі. Зберігати у сухому, прохолодному, темному місті.',
				picture: require('@/assets/picolin2.webp'),
				picture2: require('@/assets/picolin1.webp'),
			},
			{
				id: 12,
				qty: 1,
				name: 'Now Foods, Країна виробник: США',
				title: 'Echinacea (Ехінацея) 400 мг 100 капсул',
				composition:
				{
					title: 'Склад 1 капсули:',
					name1: 'Total Carbohydrate (вуглеводи)',
					name2: 'Echinacea root (коріння ехінацеї)',
					quantity: '< 1 г ',
					quantity2: '800 мкг',
					dp: '<1*',
					dp1: '+',
					text1: '+Добова потреба не визначена',
					text2: '*Добова потреба розрахована на дієту у 2000 калорій',
					text3: 'Інші інгредієнти: целюлоза (капсула), стеаринова кислота (овочевого походження).',
				},
				properties: ['є імуномодулятором, стимулює клітинний, місцевий та загальний імунітет, посилює вироблення інтерферону, активує Т-лімфоцити та макрофаги;',
					'оказує антивірусну та антиалергійну дію, знижує проникливість мембран для бактерій та вірусів;',
					'ехінацея - природний антибіотик широкого спектру дії;',
					'підвищує резистентність організму до інфекційних та вірусних захворювань, прискорює процес одуження;',
					'оказує прямий протизапалювальний та відхаркувальний ефект;',
					'має кортизоноподібну активність;',
					'за дією перевершує нестероїдні протизапалювальні препарати, знижує ризик розвитку дізбактеріозу;',
					'флавоноїди ехінацеї оказують антиоксидантну дію;',
					'має антисептичну, протипаразитарну та протигрибкову дію;',
					'видаляє отруйні речовини та токсини з організму;',
					'є добрим очищувачем крові та лімфатичної системи, виводить продукти життєдіяльності мікробів, застосовується в лікуванні при укусах змій;',
					'знижує ризик появи пухлин.',
				],
				application: ['гострі інфекційні захворювання (грип, ГРВІ, кір, інфекційний мононеклеоз, туберкульоз);',
					'бронхіти, пневмонії;',
					'ангіна, хронічний тонзиліт та інші ЛОР-захворювання;',
					'вітряна віспа, паротит, скарлатина, малярія;',
					'запалювальні гінекологічні захворювання;',
					'хронічні запалювальні захворювання сечовивідних шляхів - цистит, уретрит, цистопієліт, пієлонефрит;',
					'запалювальні захворювання органів травлення - гастрит, холецистит, панкреатит, ентероколіт;',
					'запалювальні захворювання серцево-судинної системи - міокардит, томбофлебіт;',
					'запалювальні захворювання нервової системи - поліневріти, менінгіти, арахноідити;',
					'запалювання суглобів;',
					'отруєння різної етіології;',
					'укуси змій;',
					'онкологічні захворювання.',
				],
				price: 9.77,
				way: 'по 2 капсулі 1-4 рази на день під час їжі. Зберігати у сухому, прохолодному, темному місті.',
				picture: require('@/assets/echinacea1.webp'),
				picture2: require('@/assets/echinacea2.webp'),
			},
			{
				id: 13,
				qty: 1,
				name: 'Now Foods, Країна виробник: США',
				title: 'Melatonin (Мелатонін) 3 мг 60 капсул',
				composition:
				{
					title: 'Склад 1 капсули:',
					name1: 'Melatonin (мелатонін)',
					quantity: '3 мг',
					dp: '+',
					text1: '+Добова потреба не визначена',
					text2: 'Інші інгредієнти: рисове борошно та целюлоза (капсула).',
				},
				properties: ['гормон шишкоподібної залози;',
					'потужний природний антиоксідант;',
					'підтримує точну сінхронізацію циклу сну-неспання з чергуванням дня та ночі;',
					'оказує стимулюючу дію на фермент глютатіонпароксідазу;',
					'проникає в будь-яку клітину будь-якої системи організму та в середині клітини оказує специфічну захисну дію на ядро та на ДНК, дозволяючи ушкодженій клітині відновитися, тим самим виявляючи онкопротекторну дію;',
					'підвищує загальний імунітет, гальмує процеси старіння, має захисні властивості від стресів, депресивних станів;',
					'благотворно сприяє на статеву активність.',
				],
				application: ['порушення сну;',
					'синдром неспокійних ніг;',
					'депресії, фобії (страхи), стреси;',
					'неврологічні розлади;',
					'хвороба Альцгеймера;',
					'імунні дефіцити;',
					'катаракта;',
					'пухлинні новоутворення шкіри, молочних залоз, передміхурової залози, саркоїдоз.',
				],
				price: 5.69,
				way: 'по 1 капсулі на день перед сном, запиваючи водою. Зберігати у сухому, прохолодному, темному місті.',
				picture: require('@/assets/melat1.webp'),
				picture2: require('@/assets/melat2.webp'),
			},
			{
				id: 14,
				qty: 1,
				name: 'Now Foods, Країна виробник: США',
				title: '5-HTP (5_гідрокситриптофан) 50 мг 30 капсул',
				composition:
				{
					title: 'Склад 1 капсули:',
					name1: '5-HTP (5-hydroxytryptophan) (5-гідрокситриптофан)',
					quantity: '50 мг',
					dp: '+',
					text1: '+Добова потреба не визначена',
					text2: 'Інші інгредієнти: рисове борошно та целюлоза (капсула).',
				},
				properties: ['оказує антидепресівну та заспокойливу дію;',
					'викликає розумове розслаблення та створює відчуття емоційного благополуччя;',
					'бере участь у сінтезі білків, нікотинової кислоти;',
					'знижує вміст у крові жирів, які утворюють холестерин;',
					'розширює кровоносні судини.',
				],
				application: ['безсоння;',
					'депресії;',
					'емоційні розлади;',
					'алкогольна залежність;',
					'синдром Дауна;',
					'агресивна поведінка;',
					'шизофренія;',
					'дефіцит уваги;',
					'фіброміалгії;',
					'синдром хронічної втоми;',
					'захворювання серцево-судинної системи.',
				],
				price: 6.41,
				way: 'по 1 капсулі на день перед сном, запиваючи водою. Зберігати у сухому, прохолодному, темному місті.',
				picture: require('@/assets/5-htp1.webp'),
				picture2: require('@/assets/5-htp2.webp'),
			},
			{
				id: 15,
				qty: 1,
				name: 'Now Foods, Країна виробник: США',
				title: 'Zinc (Цинк) 50 мг, 100 таблеток',
				composition:
				{
					title: 'Склад 1 таблетки',
					name1: 'Zinc (from Zinc Gluconate) (цинку глюконат)',
					quantity: '50 мг',
					dp: '455',
					text1: 'Інші інгредієнти: целюлоза, магнію стеарат, кремній.',
				},
				properties: ['входить до складу ферменту супероксиддісмутази, який перешкоджає внутриклітинному виробленню вільних радикалів у процесі окислювально-відновлювальних реакцій;',
					'сприяє синтезу білка та формуванню сполучної тканини, підтримує кислотно-лужний баланс в организмі;',
					'є складовою частиною складних ферментних систем, які формують ДНК;',
					'сприяє засвоєнню та підсиленню дії вітамінів групи В, бере участь у кровотворенні;',
					'нормалізує цукор крові;',
					'при дефіциті цинку зменшується розумова активність, нюх, смакові відчуття, втрачається волосся, гальмується зріст у дітей, з’являються стоматити, глосит, виразки на язику та яснах, можливе утворення жовчних каменів, остеопороз та ін.;',
					'підвищена потреба у цинку з’являється при стресі, впливі отруйних металів, пестицидів;',
					'бере участь у синтезі гонадотропину, нормалізує функцію передміхурової залози, нормалізує менструальний цикл, сприяє нормальному зрозтанню плоду;',
					'при дефіциті цинку виникає ураження органів травлення, та також порушення психіки;',
					'оказує виражену антиоксидантну дію.',
				],
				application: ['гострі та хронічні інфекційні захворювання;',
					'цукровий діабет;',
					'шлунково-кишкові захворювання (виразкова хвороба, харчові алергії, втрата апетіту, хвороба Крона, дизентерія);',
					'активація репаративних процесів (загоєння виразок, ран, опіків та ін.);',
					'гострі та хронічні захворювання передміхурової залози, профілактика злоякісного переродження простати;',
					'статеві розлади у чоловіків;',
					'порушення менструального циклу;',
					'порушення пам’яті;',
					'стареча деменція;',
					'нервово-психічні захворювання (хвороба Альцгеймера, шизофренія, епілепсія, депресія, розсіяний склероз, гострий психоз, недоумство та ін.);',
					'вегетаріанцям та особам старіше 55 років;',
					'особам, які вживають алкоголь та наркотики;',
					'стресові стани;',
					'погіршення зору;',
					'ревматоїдний артрит;',
					'серповидноклітинна анемія;',
					'СНІД;',
					'імунодефіцитний стан;',
					'злоякісні пухлини на ранніх стадіях;',
					'для підвищення імунітету.',
				],
				price: 6.65,
				way: 'по 1 таблетці на день під час їжі. Зберігати у сухому, прохолодному, темному місті.',
				picture: require('@/assets/zinc1.webp'),
				picture2: require('@/assets/zinc2.webp'),
			},
			{
				id: 16,
				qty: 1,
				name: 'Now Foods, Країна виробник: США',
				title: 'Selenium (Селен) 100 мкг 100 таблеток',
				composition:
				{
					title: 'Склад 1 таблетки',
					name1: 'Selenium (as L-Selenomethionine) (селен)',
					quantity: '100 мкг',
					dp: '182',
					text1: 'Інші інгредієнти: целюлоза, стеаринова кислота, магнію стеарат.',
				},
				properties: ['мікроелемент, який входить до складу більшості гормонів та ферментів, та таким чином пов’язаний з усіма рганами та системами;',
					'є потужним антиоксидантом, виводить з організму іони важких металів, у т.ч. кадмій та миш’як;',
					'знижує рівень цукру у крові;',
					'має кардіопротекторну дію, попереджує розпад міокардіоцитів;',
					'підвищує імунітет, впливає на швидкість вироблення антитіл;',
					'амінокислоти, які містять селен, обладають гепатопротекторною дією;',
					'має онкопротекторний вплив та здатен до здатен до зниження захворюваності раком майже на 40%;',
					'дефіцит селену призводить до захворювань органів зору, випадіння волосся, появи зобу, остеохондрозу, захворюваннь суглобів, анемії та ін.',
				],
				application: ['гострі та хронічні інфекційні захворювання;',
					'туберкульоз;',
					'серцево-судинні захворювання (міокардіодистрофія, міокардіопатія, гіпертонія, ІХС, гіпотонія, варикоз);',
					'гіперхолестериномія;',
					'вірусний гепатит, цироз печінки;',
					'панкреатит;',
					'жовчокам’яна хвороба;',
					'остеохондроз;',
					'артроз, артрити;',
					'хвороба Бехтерева;',
					'поліневрит;',
					'хвороба Паркінсона;',
					'інсульт;',
					'цукровий діабет;',
					'захворювання щитовидної залози;',
					'псоріаз, дерматіти, опіки;',
					'гінгівіти, стоматити;',
					'нефрологія: пієлонефрит, мочекам’яна хвороба;',
					'гострі та хронічні захворювання органів дихання;',
					'профілактика токсикозу, викіднів;',
					'хвороби крові: анемії, лейкози, гемофілія, промінева хвороба;',
					'доброякісні пухлини;',
					'СНІД;',
					'попередження передчасного старіння.',
				],
				price: 6.89,
				way: 'по 1 таблетці на день під час їжі. Зберігати у сухому, прохолодному, темному місті.',
				picture: require('@/assets/selen1.webp'),
				picture2: require('@/assets/selen2.webp'),
			},
			{
				id: 17,
				qty: 1,
				name: 'Now Foods, Країна виробник: США',
				title: 'C-500 (Вітамін С-500 комплекс) 500 мг 100 таблеток',
				composition:
				{
					title: 'Склад 1 таблетки',
					name1: 'Vitamin C (as Ascorbic Acid) (вітамін С (аскорбинова кислота))',
					name2: 'Rose Hips Powder (Fruit) (порошок ягід шипшини)',
					quantity: '500 мг',
					quantity2: '40 г',
					dp: '556*',
					dp1: '+',
					text1: '*Добова потреба розрахована на дієту у 2000 калорій',
					text2: '+Добова потреба не визначена',
					text3: 'Інші інгредієнти: целюлоза (капсула), стеаринова кислота (овочевого походження), магнію стеарат (овочевого походження), кремній.',
				},
				properties: ['є основним компонентом окислювально-відновлювальних процесів у клітинах;',
					'бере участь у синтезі амінокислот у процесі транспортування електронів на кінцевому етапі тканинного дихання;',
					'оказує потужну антиоксиданту дію;',
					'стабілізує клітинні мембрани, знижує проникливість стінок капілярів;',
					'відновлює еластичність судин;',
					'відновлює колаген;',
					'знижує рівень холестерину у крові;',
					'покращує засвоювання заліза;',
					'сприяє регенерації тканин, знешкоджує токсини;',
					'посилює імунітет організму;',
					'попереджує розвиток остеопорозу, алергійних реакцій;',
					'регулює ритм роботи серця;',
					'оказує антистресову дію, звільняє людину від наркотичної залежності;',
					'має протизапалювальну, антибактеріальну, антивірусну та протипухлинну дію;',
					'підвищує кислотність шлункового соку;',
					'усуває набряки;',
					'оказує сечогінну, кровозупиняючу, заспокійливу, жовчогонну, зв’язуючу та вітрогонну дію.',
				],
				application: ['гострі та хронічні інфекційні захворювання вірусної та бактеріальної природи;',
					'аутоімунні захворювання (геморагійний васкуліт, ревматоїдний артрит);',
					'герпетична інфекція (очей, шкіри, геніталій);',
					'інтоксикація організму;',
					'травми, опіки, пролежні;',
					'захворювання, що протікають з геморагічним синдромом;',
					'серцево-судинні захворювання, захворювання органів дихання та сечостатевих шляхів;',
					'лікування запалювально-дістрофічних артритів;',
					'залізодефіцитні анемії;',
					'лікування СНІДу та ін. імунодефіцитних станів;',
					'застосування у стоматології;',
					'онкозахворювання та передракові стани;',
					'промінева хвороба, хіміотерапія;',
					'алкогольна інтоксикація, тютюнопаління;',
					'діабет, ожиріння;',
					'стресові ситуації;',
					'особам, які перебувають у екологічно несприятливих зонах.',
				],
				price: 7.66,
				way: 'по 1 таблетціі 1-2 рази на день. Зберігати у сухому, прохолодному, темному місті.',
				picture: require('@/assets/c5001.webp'),
				picture2: require('@/assets/c5002.webp'),
			},
			{
				id: 18,
				qty: 1,
				name: 'Now Foods, Країна виробник: США',
				title: 'Hawthorn Berry (Глід) 540 мг 100 капсул',
				composition:
				{
					title: 'Склад 2 капсул:',
					name1: 'Total Carbohydrate (вуглеводи)',
					name2: 'Hawthorn berry (fruit) (плоди глоду)',
					quantity: '1 г',
					quantity2: '1,1 г',
					dp: '<1*',
					dp1: '+',
					text1: '*Добова потреба розрахована на дієту у 2000 калорій',
					text2: '+Добова потреба не визначена',
					text3: 'Інші інгредієнти: целюлоза, стеаринова кислота (овочевого походження).',
				},
				properties: ['посилює метаболізм у серцевому м’язі;',
					'підвищує постачання кисню до серцевого м’язу та нейронів головного мозку;',
					'усуває порушення ритму серця, підвищує силу скорочень та об’єм крові, що перекачувається;',
					'нормалізує артеріальний тиск;',
					'обладає протиатеросклеротичною дією;',
					'оказує спазмолітичний ефект та м’яку сечогінну дію;',
					'сприяє зниженню холестерину у крові;',
					'оказує м’яку судинорозширювальну дію на коронарні судини, завдяки чому покращує живлення серцевого м’язу.',
				],
				application: ['функціональні роздади серцевої діяльності;',
					'гіпертонічна хвороба;',
					'вегето-судинна дистонія по гіпертонічному типу;',
					'стенокардія;',
					'миготлива аритмія;',
					'пароксизмальна тахікардія;',
					'міокардіодистрофія;',
					'атеросклероз;',
					'клімактерічний невроз.',
				],
				price: 9.84,
				way: 'по 2 капсули 3 рази на день під час їжі. Зберігати у сухому, прохолодному, темному місті.',
				picture: require('@/assets/berry1.webp'),
				picture2: require('@/assets/berry2.webp'),
			},
			{
				id: 19,
				qty: 1,
				name: 'Now Foods, Країна виробник: США',
				title: 'Pau D\'Arco (По Д\'Арко) 500 мг 100 капсул',
				composition:
				{
					title: 'Склад 2 капсул:',
					name1: 'Total Carbohydrate (вуглеводи) ',
					name2: 'Pau D’Arco (inner bark)(по д’арко (внутрішня частина кори))',
					quantity: '<1 г',
					quantity2: '1 г (1000 мг)',
					dp: '<1%*',
					dp1: '+',
					text1: '*Добова потреба розрахована на дієту у 2000 калорій',
					text2: '+Добова потреба не визначена',
					text3: 'Інші інгредієнти: целюлозна капсула та стеаринова кислота овочевого походження.',
				},
				properties: ['є прирородним антибіотиком, який оказує антибактеріальну дію проти грам-позитивних (стафілококи, стрептококи) та грам-негативних (бруцели) бактерій, мікобактерій туберкульозу;',
					'має противірусну, протигрибкову та антипаразитарну дію;',
					'збільшує імунну функцію організму, є індуктором інтерферогенезу, оказує протилихоманкову дію;',
					'має протипухлинні властивості;',
					'складається з 18 різних сполучень, але найбільш активними з них є липахол та келодин;',
					'є потужним прирородним антиоксідантом;',
					'покращує обмін речовин;',
					'оказує тонізуючу та детоксікаційну дію, знижує рівень цукру у крові;',
					'покращує травлення;',
					'має виражену болепоглинаючу дію.',
				],
				application: ['грип, ГРВІ;',
					'бронхіти, пневмонії, отіти, сінусити, бронхіальна астма;',
					'герпес, СНІД;',
					'туберкульоз легень;',
					'грибкові захворювання;',
					'кандідози;',
					'захворювання шкіри: фурункульоз, вугри, екзема, дерматози, вітиліго, псоріаз, виразки, рани, вовчак;',
					'захворюваня шлунково-кишкового тракту: гастрити, виразки, поліпи, дизинтерія, захворювання печінки;',
					'захворювання сечостатевої системи: цистити, пієліти, уретрити, пієлонефрити, простатіти;',
					'хвороби крові: анемії, лімфаденіти, мононуклеоз, лейкоз, лімфогрануломатоз та ін.;',
					'запалювальні захворювання суглобів, ревматизм;',
					'цукровий діабет I та II типу;',
					'онкозахворювання.',
				],
				price: 10.09,
				way: 'по 2 капсули 1-2 рази на день. Зберігати у сухому, прохолодному, темному місті.',
				picture: require('@/assets/pau1.webp'),
				picture2: require('@/assets/pau2.webp'),
			},
			{
				id: 20,
				qty: 1,
				name: 'Now Foods, Країна виробник: США',
				title: 'E-200 (Вітамін Е-200) 100 капсул',
				composition:
				{
					title: 'Склад 1 капсули:',
					name1: 'Vitamin E (as d-alpha Tocoferol) (вітамін E (d-альфатокоферол))',
					quantity: '134 мг (200МО)',
					dp: '893*',
					text1: '*Добова потреба розрахована на дієту у 2000 калорій',
					text2: 'Інші інгредієнти: капсула, олівкова олія, суміш токоферолів (d-бета, d-дельта, d-гама).',
				},
				properties: ['оказує виражену антиоксиданту дію;',
					'нормалізує окислювально-відновлювальних процеси, укріплюючи мембрани клітин;',
					'покращує функціонування серцево-судинної системи;',
					'оказує антисклеротичну та антитромботичну дію;',
					'нормалізує холестериновий обмін;',
					'має онкопротекторну дію;',
					'нормалізує функцію органу зору;',
					'є ранозагоюючим засобом;',
					'оказує імуностимулюючу дію;',
					'покращує стан органів травлення (печінки, жовчного міхура, підшлункової залози);',
					'сприяє нормальному росту та розвитку організму.',
				],
				application: ['захворювання серцево-судинної системи (атеросклероз, гіпертонічна хвороба, міокардіодистрофія, варикозне розширення вен, тромбофлебіт, облітеруючий ендартеріїт);',
					'для омолодження організму, нормального росту та розвитку, попередження старіння;',
					'хвороба Паркінсона;',
					'хвороба Альцгеймера;',
					'для нормалізації статевої функції у чоловіків та жінок;',
					'підчас вагітності, при дисфункціональних маточних кровотечах, підчас годування груддю;',
					'ендометріоз;',
					'алергійні дерматити;',
					'рани, опіки, опрілості, укуси комах;',
					'червоний вовчак, склеродермія;',
					'онкозахворювання кишківника, молочної залози, легенів, горлянки та жіночих органів;',
					'аденома передміхурової залози;',
					'ускладнення проміневої- та хіміотерапії;',
					'артрити;',
					'анемії;',
					'діабет;',
					'захворювання очей (катаракта, глаукома та прогресуюча міопатія);',
					'захворювання печінки, жовчного міхура, підшлункової залози;',
					'геморой, який ускладнений тромбозом;',
					'виразкова хвороба шлунку та дванадцятипалої кишки;',
					'пародонтоз.',
				],
				price: 11.68,
				way: 'по 1 капсулі 1-4 рази на день підчас їжі. Зберігати у сухому, прохолодному, темному місті.',
				picture: require('@/assets/e200-1.webp'),
				picture2: require('@/assets/e200-2.webp'),
			},
			{
				id: 21,
				qty: 1,
				name: 'Now Foods, Країна виробник: США',
				title: 'L-Carnitine (L-карнітин) 250 мг 60 капсул',
				composition:
				{
					title: 'Склад 2 капсул:',
					name1: 'L-Carnitine (Carnypure™) (from L-Carnitine Tartrate) (L-карнітин)',
					quantity: '500 мг',
					dp: '+',
					text2: '+Добова потреба не визначена',
					text3: 'Інші інгредієнти: целюлоза, магнію стеарат (овочевого походження), кремній.',
				},
				properties: ['основна частина карнітину у людському організмі синтезується з насичених амінокислот лізину та метіоніну, вітамінів С, В3, В6 та заліза, дефіціт кожного з цих компонентів призводить до дефіциту карнітину, та тим самим до погіршення жирового обміну, та до накопичення жирів у м’язах попереку, серцевому м’язі та клітинах печінки;',
					'є транспортним засобом для жирів, здійснює їх оксігенацію, тобто згоряння у мітохондріях;',
					'виводить з організму (з цитоплазми) токсини, шлаки, метаболіти, так зване “вуглицеве сміття”;',
					'сприяє виведенню з організму аміаку, який отруюює організм;',
					'сприяє засвоєнню їжі та розщепленню жирів;',
					'забезпечує енергетичні потреби серцево-судинної системи (при дефіциті карнітину розвиваються кардіоміопатії);',
					'відновлює розумову енергію, гальмує старіння клітин мозку, покращує настрій;',
					'корегує імунну систему організму, захищає його від інфекцій та аутоімунних захворювань;',
					'сприяє виробленню в организмі потужного антиоксиданту - коферменту Q10.',
				],
				application: ['серцево-судинні захворювання: гіпертонія, міокардит, кардіоміопатія, застійна серцева недостатність, атеросклероз, стенокардія, інфаркт міокарда;',
					'захворювання нервової системи: інсульт, хвороба Альцгеймера, хвороба Паркінсона;',
					'синдром хронічної втоми;',
					'атрофія м’язів;',
					'туберкульоз;',
					'СНІД;',
					'гіпотеріоз;',
					'програма зниження маси тіла, очищення організму, омолодження;',
					'цукровий діабет, жировий гепатоз, ожиріння, алкоголізм;',
					'надмірні фізичні навантаження (у спортсменів);',
					'знижує накопичення молочної кислоти та усуває біль у м‘язах;',
					'вегетаріанство.',
				],
				price: 12.17,
				way: 'по 2 капсули 1-3 рази на день між прийомами їжі. Зберігати у сухому, прохолодному, темному місті.',
				picture: require('@/assets/lc1.webp'),
				picture2: require('@/assets/lc2.webp'),
			},
			{
				id: 22,
				qty: 1,
				name: 'Now Foods, Країна виробник: США',
				title: 'Ginkgo Biloba (Гінкго білоба) 60 мг 120 капсул',
				composition:
				{
					title: 'Склад 1 капсули:',
					name1: 'Ginkgo Extract (Leaf) (50:1 Standardized Extract, min. 24% Ginkgoflavonglycosides and 6% Terpene Lactones) (екстракт листя гінкго (50:1 стандартизований екстракт, що містить 24% Гінкгофлавонглікозидів та 6% терпенових лактонів))',
					name2: 'Ginkgo Powder (Leaf) (порошок листя Гінкго)',
					quantity: '60 мг',
					quantity2: '200 мг',
					dp: '+',
					dp1: '+',
					text2: '+Добова потреба не визначена',
					text3: 'Інші інгредієнти: овочевий полісахарид (капсула), магнію стеарат (овочевого походження).',
				},
				properties: ['нормалізує мозковий та коронарний кровообіг, відновлює пам’ять, слух, зір, мовні та рухові функції, усуває циркуляторну недостатність;',
					'відновлює еластичність та міцність судин, запобігає виникненню тромбозів мозкових та коронарних судин;',
					'підвищує приплив крові до органів, артерій та вен, які цього потребують;',
					'відновлює гематоенцефалітичний бар’єр, іонний склад та провідність нервових клітин, та постачання до них кисню;',
					'оказує протинабрякову дію на тканини головного мозку та переферичні тканини;',
					'має антиоксиданту дію, нормалізує метаболічні процеси та зберігає цілісність та провідність клітинної стінки;',
					'знижує рівень холестерину у крові та забезпечує зниження споживання інсуліну;',
					'оказує бактеріцидну, відхаркуючу то жовчогінну дію;',
					'має імуномоделюючі, противірусні властивості;',
					'нормалізує артеріальний тиск, оказує судинорозширювальну та бронхоспастичну дію;',
					'посилює потенцію та підвищує фізичну працездатність;',
					'покращує психомовний розвиток при енцефалопатіях.',
				],
				application: ['церебральна (мозкова) недостатність;',
					'вікові погіршення пам’яті, зміни слухових та зорових функцій;',
					'депресії;',
					'головний біль, мігрень, шум в ухах, запаморочення;',
					'хвороба Альцгеймера;',
					'безсоння;',
					'гіпертонічна хвороба;',
					'вегето-судинна дистонія;',
					'атеросклероз судин головного мозку;',
					'профілактика інсульту та інфаркту;',
					'реабілітація ішемічних інсультів та коронарних тромбозів, набряк мозку;',
					'черепно-мозкові травми;',
					'варикозне розширення вен, тромбофлебіт, геморой;',
					'хронічна артеріальна облітерація, діабетична та ангіосклеротична ангіопатія;',
					'гормональні порушення;',
					'імунодефіцитні стани;',
					'зловживання палінням;',
					'синдром хронічної втоми;',
					'цукровий діабет;',
					'передменструальний синдром;',
					'лікування захворювань органів зору (катаракта, ретінопатія та ін.).',
				],
				price: 16.13,
				way: 'по 1 капсулі 1-2 рази на день. Зберігати у сухому, прохолодному, темному місті.',
				picture: require('@/assets/gb1.webp'),
				picture2: require('@/assets/gb2.webp'),
			},
			{
				id: 23,
				qty: 1,
				name: 'Now Foods, Країна виробник: США',
				title: 'CoQ10 (Кофермент Q10) 30 мг 60 капсул',
				composition:
				{
					title: 'Склад 1 капсули:',
					name1: 'Coenzyme Q10 (CoQ10) (кофермент Q10)',
					quantity: '30 мг',
					dp: '+',
					text2: '+Добова потреба не визначена',
					text3: 'Інші інгредієнти: целюлоза (капсула), рисове борошно.',
				},
				properties: ['синтезується у печінці, основним джерелом поповнення є продукти харчування (м’ясо, печінка та ін.), вживання яких протипоказано хворим атеросклерозом, особам, які мають підвищений вміст холестерину у крові, при ожирінні, тому їм більш за все необхіден синтезований кофермент Q-10;',
					'особливо великою є потреба у коферменті Q-10 для таких органів, як серце, печінка, почки, підшлункова залоза, мозок, діяльність яких потребує великих витрат енергії;',
					'нормалізує енергетику клітини, відновлює її функції, бере участь у синтезі АТФ - універсального носія енергії в организмі;',
					'дефіцит коферменту Q-10 призводить до порушення обміну речовин;',
					'запобігає перекисному окисленню ліпідів низької щільності;',
					'оказує антиоксидантий вплив;',
					'знижує в’язкість крові, усуває побочні явища при радіо- та хіміотерапії;',
					'підсилює дію інших ферментів;',
					'прискорює енергетичні та обмінні процеси в организмі;',
					'на відміну від інших ферментів (АТФ, кокарбоксилаза) кофермент Q-10 добре засвоюється при внутрішньому прийомі.',
				],
				application: ['профілактика та лікування серцево-судинних захворювань (атеросклерозу, гіпертонічної хвороби, кардіоміопатій, застійної серцевої недостатньості, пролапсу мітрального клапану, арітмій, клапанних пороків серця, ішемічної хвороби серця, стенокардії, інфаркту міокарду);',
					'профілактика та лікування інсульту, хвороби Альцгеймера, розсіяного склерозу, хвороби Паркінсона, енцефалопатії, попередження вікових змін у мозку;',
					'хвороба Меньєра;',
					'переферичний параліч лицьового нерву;',
					'програма зниження маси тіла;',
					'м’язова дистрофія та міопатія;',
					'профілактика та лікування астенічного синдрому;',
					'імунодефіцитні стани;',
					'інфіковані ВІЛ та хворі на СНІД;',
					'цукровий діабет;',
					'алергійні захворювання, у т.ч. і бронхіальна астма;',
					'профілактика та лікування пародонтозу та інших захворювань ясен;',
					'програма лікування злоякісних пухлин (рак грудей, легень, передміхурової залози);',
					'анемії та онкогематологічні захворювання;',
					'підготування до порожнинних операцій та післяопераційний період;',
					'профілактика та лікування виразкової хвороби;',
					'глухота;',
					'попередження викиднів;',
					'омолодження організму;',
					'гальмування процесів старіння в организмі;',
					'профілактика та лікування астенічного синдрому та синдрому хронічної втоми;',
					'стимуляція імунітету та адаптивних реакцій організму.',
				],
				price: 9.7,
				way: 'по 1 капсулі на день, бажано під час їжі. Зберігати у сухому, прохолодному, темному місті.',
				picture: require('@/assets/q10-1.webp'),
				picture2: require('@/assets/q10-2.webp'),
			},
			{
				id: 24,
				qty: 1,
				name: 'Now Foods, Країна виробник: США',
				title: 'Evening Primrose Oil (Масло примули вечірньої) 500 мг 100 капсул',
				composition:
				{
					title: 'Склад 3 капсул:',
					name1: 'Calories (калорії)',
					name2: 'Total Fat (жири)',
					name3: 'Polyunsaturated Fat (поліненасичені жири)',
					name4: 'Monounsaturated Fat (мононенасичені жири)',
					name5: 'Evening Primrose Oil (Seed) (Cold-Pressed, Hexane-Free) (масло примули вечірньої (зерна холодного віджиму, без гексану))',
					name6: 'Gamma-Linolenic Acid (GLA) (гамма-ліноленова кислота (ГЛК))',
					quantity: '15',
					quantity2: '1,5 г',
					quantity3: '1 г',
					quantity4: '<0,5 г',
					quantity5: '1,5 г',
					quantity6: '135 мг',
					dp: '',
					dp1: '2*',
					dp2: '+',
					dp3: '+',
					dp4: '+',
					dp5: '+',
					text1: '*Добова потреба розрахована на дієту у 2000 калорій',
					text2: '+Добова потреба не визначена',
					text3: 'Інші інгредієнти: желатинова капсула.',
				},
				properties: ['містить незамінні поліненасичені жирні кислоти;',
					'має вплив на синтез простогландинів та стероїдних гормонів, у т.ч. і статевих;',
					'впливає на синтез гліко- та фосфоліпідів, які приймають участь у будуванні усіх клітинних мембран;',
					'знижує рівень холестерину у крові;',
					'оказує протизапальну та протибольову дію;',
					'сприяє профілактиці серцево-судинних захворювань (збільшеного артеріального тиску, перешкоджає тромбоутворенню);',
					'сприяє профілактиці передменструального синдрому (усуває припливи);',
					'сприяє профілактиці розсіяного склерозу;',
					'посилює виділенння статевих гормонів, включаючи естроген та тестостерон;',
					'оказує заспокоюючий ефект;',
					'нормалізує обмін речовин у сітківці ока;',
					'збільшує рівень лейкотриєнів, регулює рівень імунного захисту;',
					'нормалізує роботу центральної нервової системи, функції мозку та покращує передавання нервових імпульсів.',
				],
				application: ['серцево-судинні захворювання: атеросклероз, гіпертонічна хвороба, стенокардія, інсульт, інфаркт, тромбофлебіт, облітеруючі захворювання нижніх кінцевок;',
					'ревматоїдний артрит;',
					'захворювання центральної та переферичної нервової системи;',
					'депресивні стани;',
					'похмільний синдром;',
					'розсіяний склероз;',
					'нервові стреси;',
					'мігрені;',
					'порушення функцій системи згортання крові;',
					'дисгормональні стани у чоловіків та жінок, які пов’язані зі зниженням рівня статевих гормонів (дисменорея, амінорея, безпліддя, статева слабкість у чоловіків, жіноча фригідність);',
					'захворювання простати;',
					'ендометріоз, мастопатія;',
					'діабет, зниження зору, яке пов’язане з ретинопатією;',
					'ожиріння;',
					'аутоімунні захворювання;',
					'реабілітація після тяжких інфекційних хвороб те перенесених інтоксикацій;',
					'бронхіальна астма;',
					'виразкові коліти;',
					'злоякісні пухлини;',
					'лікування ран, які не загоюються;',
					'екзема, юнацькі вугри, псоріаз;',
					'омолодження шкіри, ламкість нігтів, лупа.',
				],
				price: 10.77,
				way: 'по 3 капсули 1-2 рази на день під час їжі. Зберігати у сухому, прохолодному, темному місті.',
				picture: require('@/assets/rose1.webp'),
				picture2: require('@/assets/rose2.webp'),
			},
			{
				id: 25,
				qty: 1,
				name: 'Now Foods, Країна виробник: США',
				title: 'Inositol (Інозітол) 500 мг 100 капсул',
				composition:
				{
					title: 'Склад 1 капсули:',
					name1: 'Inositol (Інозітол) 500 мг 100 капсул',
					quantity: '500 мг',
					dp: '+',
					text2: '+Добова потреба не визначена',
					text3: 'Інші інгредієнти: рисове борошно та целюлоза (капсула), стеаринова кислота (овочевого походження), кремнію диоксид.',
				},
				properties: ['усуває нервове напруження;',
					'оказує снодійну дію;',
					'підтримує обмін жирів у печінці;',
					'знижує масу тіла - спалює зайві жири;',
					'прискорює уповільнений метаболізм в организмі;',
					'сприяє росту нервових клітин у новонароджених;',
					'перешкоджає втраті зору;',
					'запобігає порушенням дихання.',
				],
				application: ['депресії;',
					'важкі форми тривоги;',
					'нервове напруження;',
					'неврози;',
					'нав’язливі стани;',
					'діабетична невропатія;',
					'безсоння;',
					'надлишкова маса тіла, ожиріння;',
					'порушення мовлення;',
					'хвороба Альцгеймера - для орієнтування та відновлення мовлення;',
					'недоношеним малюкам.',
				],
				price: 10.77,
				way: 'по 1 капсулі 1-3 рази на день. Зберігати у сухому, прохолодному, темному місті.',
				picture: require('@/assets/inositol1.webp'),
				picture2: require('@/assets/inositol2.webp'),
			},
			{
				id: 26,
				qty: 1,
				name: 'Now Foods, Країна виробник: США',
				title: 'Taurine (Таурин) 500 мг 100 капсул',
				composition:
				{
					title: 'Склад 1 капсули:',
					name1: 'Taurine (Free-Form) (таурин)',
					quantity: '500 мг',
					dp: '+',
					text2: '+Добова потреба не визначена',
					text3: 'Інші інгредієнти: желатинова капсула та рисове борошно.',
				},
				properties: ['є натуральною амінокислотою, яка синтезується печінкою та іншими органами з цистеїну та метіоніну, та бере участь у синтезі багатьох інших амінокислот;',
					'підвищує імунітет,',
					'оказує антиоксидантний захист;',
					'бере участь у травленні жирів, адсорбує жиророзчинні вітаміни;',
					'нормалізує рівень холестерину у крові;',
					'нормалізує рівень цукру у крові, нормалізує обмін калію, натрію, кальцію та магнію, регулює водно-сольовий баланс, оказує сечогінну дію;',
					'сприяє росту;',
					'є необхідним для нормального розвитку нервової системи, м’язів та сітківки ока;',
					'нормалізує серцевий ритм та тонус судин;',
					'знижує небезпеку утворення тромбів;',
					'захищає клітинні мембрани від пошкоджень, захищає організм від токсичного впливу ліків при хіміотерапії;',
					'покращує обмінні енергетичні процеси в организмі.',
				],
				application: ['захворювання серця - атеросклероз, гіпертонічна хвороба, аритмії, серцева недостатність з набряками та тромбоутворенням;',
					'захворювання нервової системи: занепокоєння, збудження, гіперактивність, судоми, епілепсія, синдром Дауна, стреси, зловживання алкоголем;',
					'порушення водного балансу;',
					'ниркові, серцеві набряки;',
					'передменструальний синдром з набряком тканин;',
					'дистрофічні ураження сітківки ока;',
					'травми рогівки, травматичні катаракти;',
					'глаукома;',
					'вікові порушення зору;',
					'проміневі ураження;',
					'цукровий діабет;',
					'жирова дистрофія печінки;',
					'жовчокам\'яна хвороба;',
					'хронічний бронхіт, бронхіальна астма;',
					'імунодефіцитні стани;',
					'уповільнений рост у дітей, м’язові дистрофії;',
					'особам, якими були перенесені важкі травми та опіки.',
				],
				price: 8.44,
				way: 'по 1 капсулі 1-4 рази на день між прийомами їжі, запиваючи соком або водою. Зберігати у сухому, прохолодному, темному місті.',
				picture: require('@/assets/taurine1.webp'),
				picture2: require('@/assets/taurine2.webp'),
			},
			{
				id: 27,
				qty: 1,
				name: 'Now Foods, Країна виробник: США',
				title: 'Alfalfa (Люцерна) 650 мг 250 таблеток',
				composition:
				{
					title: 'Склад 3 таблеток:',
					name1: 'Calories (калорії)',
					name2: 'Total Carbohydrate (вуглеводи)',
					name3: 'Alfalfa (люцерна)',
					quantity: '5',
					quantity2: '1 г',
					quantity3: '1,95 г',
					dp: '',
					dp1: '<1*',
					dp2: '+',
					text1: '*Добова потреба розрахована на дієту у 2000 калорій',
					text2: '+Добова потреба не визначена',
					text3: 'Інші інгредієнти: дикальцію фосфат, целюлоза, стеаринова кислота (овочевого походження), кремнію диоксид, магнію стеарат (овочевого походження).',
				},
				properties: ['оказує загальноукріплюючу та детоксикуючу дію;',
					'знижує рівень холестерину у крові, перешкоджаючи атеросклеротичним змінам, ефективно регулює артеріальний тиск;',
					'укріплює серцево-судинну систему, є ефективним засобом при вегето-судинної дистонії;',
					'попереджає кровоточивість та крововиливи, є дуже дієвим засобом при геморагічному синдромі та анемії;',
					'оказує цукорознижуючу, олужуючу та протипухлинну дію;',
					'має корисну дію для жінок підчас менопаузи, збільшує лактацію у матерів, які годують груддю, та знижує ознаки токсикозу;',
					'оказує протизапальну та протигрибкову дію;',
					'сприяє загоєнню ран, виразок, ерозій;',
					'оказує сечогінну дію, виводить сечокислі солі, підвищує імунітет, знижує алергію.',
				],
				application: ['захворювання серцево-судинної системи: атеросклероз, гіпертонічна хвороба, ішемічна хвороба серця та ін.;',
					'гіперхолестеринемія;',
					'вегето-судинна дистонія;',
					'захворювання дихальної системи: бронхіти, сінусіти, туберкульоз;',
					'геморагічний синдром;',
					'анемії;',
					'виразкова хвороба шлунку, та дванадцятипалої кишки;',
					'артрити, ревматизм;',
					'подагра;',
					'алергічні захворювання, вугревий висип;',
					'захворювання сечополової системи: цистити, простатити, сечокам’яна хвороба, гломерулонефрити;',
					'порушення водно-електролітного обміну;',
					'хіміотерапія та тютюнопаління;',
					'профілактика раку грудей, мастопатія, аденома передміхурової залози;',
					'рани, виразки, ерозії, дерматити, екземи;',
					'грибкові захворювання;',
					'діабет;',
					'пародонтоз, карієс.',
				],
				price: 12.26,
				way: 'по 3 таблетки 3 рази на день між прийомами їжі. Зберігати у сухому, прохолодному, темному місті.',
				picture: require('@/assets/alf1.webp'),
				picture2: require('@/assets/alf2.webp'),
			},
			{
				id: 28,
				qty: 1,
				name: 'Now Foods, Країна виробник: США',
				title: 'Super Enzymes (Супер Ензими) 90 таблеток',
				composition:
				{
					space: true,
					title: 'Склад 1 таблетки:',
					name1: 'Calcium (from Calcium Carbonate) (кальцію карбонат)',
					name2: 'Betaine HCl (бетаїн)',
					name3: 'Ox Bile Extract (min. 45% Total Cholic Acids) (екстракт бичачої жовчи)',
					name4: 'Papaya Fruit Powder (порошок ягід папайя)',
					name5: 'Enzyme Blend: (суміш ферментів):',
					name6: ' Pancreatin 10X (панкреатин) Supplying: (містить):',
					name7: '    Amylase (амілаза) 20000 USP Units +',
					name8: '    Protease (протеаза) 20000 USP Units +',
					name9: '    Lipase (ліпаза) 1600 USP Units +',
					name10: ' Bromelain(from Pineapple) (бромелайн(з ананасу))',
					name11: ' Papain (from Papaya) (папаїн (з папайї)',
					name12: ' Cellulase (целюлаза)',
					name13: ' Pepsin (пепсин)',
					quantity: '20 мг',
					quantity2: '200 мг',
					quantity3: '100 мг',
					quantity4: '45 мг',
					quantity5: '182 мг',
					quantity6: '',
					quantity7: '',
					quantity8: '',
					quantity9: '',
					quantity10: '120 GDU',
					quantity11: '100000 FCC PU',
					quantity12: '10 FCC CU',
					quantity13: '500000 FCC',
					dp: '2',
					dp1: '+',
					dp2: '+',
					dp3: '+',
					dp4: '+',
					dp5: '',
					dp6: '',
					dp7: '',
					dp8: '',
					dp9: '+',
					dp10: '+',
					dp11: '+',
					dp12: '+',
					text2: '+Добова потреба не визначена',
					text3: 'Інші інгредієнти: целюлоза, кремній, стеаринова кислота (овочевого походження), магнію стеарат (овочевого походження), натрій та фармацевтичний глазур.',
				},
				properties: ['полегшує процес травлення - розщіплює білки, жири, вуглеводи;',
					'оказує протизапальну дію;',
					'руйнує імунні комплекси у стінках судин;',
					'має фібринолітичну активність та прискорює лізіс токсичних продуктів обміну речовин та некротизованих тканин;',
					'нормалізує в’язкість крові та мікроциркуляцію, запобігає тромбоутворенню;',
					'прискорює розсмоктування гематом та набряків;',
					'покращує постачання до тканин питомих речовин;',
					'сприяє засвоюванню заліза та інших мікроелементів;',
					'є профілактичним та лікувальним засобом при захворюваннях серцево-судинної системи, сприяє відновленню пошкоджених суглобів, сухожиль, м’язів;',
					'сприяє загоєнню ран;',
					'оказує жовчогонну дію;',
					'знижує кислотність шлункового соку;',
					'оказує болепоглинаючу, розсмоктуючу та емульгуючу дію.',
				],
				application: ['хронічні гастрити, дуоденіти, панкреатити;',
					'виразковий коліт;',
					'діабет;',
					'анемія;',
					'ревматоїдний артрит;',
					'хвороба Бехтерева;',
					'тромбофлебіти, посттромбофлебітний синдром;',
					'облітеруючий ендартеріїт, васкуліти;',
					'вторинний лімфатичний набряк;',
					'розсіяний склероз;',
					'запалювальні захворювання м’яких тканин різних органів (сінусит, бронхіт, пневмонія, цистит, цистопієліт, простатит, аднексит та ін.);',
					'мастопатія;',
					'травмування (переломи, вивихи, забої), постравматичні набряки;',
					'рани та виразки, які довго загоюються;',
					'порушення обміну речовин;',
					'ожиріння;',
					'захворювання печінки;',
					'профілактика та коплексне лікування злоякісних новоутворень;',
					'боротьба з передчасним старінням.',
				],
				price: 19.57,
				way: 'по 1 таблетці 3 рази на день під час їжі. Зберігати у сухому, прохолодному, темному місті.',
				picture: require('@/assets/super1.webp'),
				picture2: require('@/assets/super2.webp'),
			},
			{
				id: 29,
				qty: 1,
				name: 'Now Foods, Країна виробник: США',
				title: 'B-50 (Вітамін В-50) 100 капсул',
				composition:
				{
					title: 'Склад 1 капсули:',
					name1: 'Thiamin (Vitamin B-1) (from Thiamin HCl) (вітамін В-1 (тіамін))',
					name2: 'Riboflavin (Vitamin B-2) (вітамін В-2 (рибофлавин))',
					name3: 'Niacin (Vitamin B-3) (as Niacinamide) (вітамін В-3 (ніацин))',
					name4: 'Vitamin B-6 (from Pyridoxine HCl) (Вітамін В-6 (піридоксин)',
					name5: 'Folate (фолат)',
					name6: 'Vitamin B-12 (as Cyanocobalamin) (вітамін В-12 (ціанокобаламін))',
					name7: 'Biotin (біотин)',
					name8: 'Pantothenic Acid (from Calcium Pantothenate) (пантотенова кислота (кальцію пантотенат))',
					name9: 'Choline (from Choline Bitartrate) (холін бітартрат)',
					name10: 'PABA (Para-Aminobenzoic Acid) (ПАБК (параамінобензойна кислота))',
					name11: 'Inositol (інозитол)',
					quantity: '50 мг',
					quantity2: '50 мг',
					quantity3: '50 мг',
					quantity4: '50 мг',
					quantity5: '680 мкг',
					quantity6: '50 мкг',
					quantity7: '50 мкг',
					quantity8: '50 мг',
					quantity9: '25 мг',
					quantity10: '25 мг',
					quantity11: '25 мг',
					dp: '4167*',
					dp1: '3846',
					dp2: '313',
					dp3: '2941',
					dp4: '170',
					dp5: '2083',
					dp6: '167',
					dp7: '1000',
					dp8: '5',
					dp9: '+',
					dp10: '+',
					text1: '*Добова потреба розрахована на дієту у 2000 калорій',
					text2: '+Добова потреба не визначена',
					text3: 'Інші інгредієнти: желатинова капсула, мікрокристалічна целюлоза, кремнію диоксид, магнію  стеарат (овочевого походження).',
				},
				properties: ['відновлює дефицит вітамінів групи В;',
					'протистоїть стресу, депресії;',
					'укріплює нервову систему;',
					'знімає втому;',
					'підтримує здоров’я серцево-судинної системи;',
					'покращує обмін речовин;',
					'підтримує роботу шлунково-кишкового тракту.',
				],
				application: ['гіпо- та авітаміноз групи В;',
					'захворювання серцево-судинної системи;',
					'захворювання шлунково-кишкового тракту;',
					'свербіж різної етіології;',
					'захворювання шкіри;',
					'стреси, депресія;',
					'хронічна втома;',
					'алкогольна та нікотинова залежність;',
					'захворювання переферичної нервової системи.',
				],
				price: 14.86,
				way: 'по 1 капсулі на день під час їжі. Зберігати у сухому, прохолодному, темному місті.',
				picture: require('@/assets/b50-1.webp'),
				picture2: require('@/assets/b50-2.webp'),
			},
			{
				id: 30,
				qty: 1,
				bee: true,
				name: 'Now Foods, Країна виробник: США',
				title: 'Bee Pollen (Квітковий пилок) 500 мг 100 капсул',
				composition:
				{
					title: 'Склад 2 капсул:',
					name1: 'Bee Pollen Powder (порошок квіткового пилку (перга))',
					quantity: '1000 мг',
					dp: '+',
					text1: '+Добова потреба не визначена',
					text2: 'Інші інгредієнти: желатинова капсула, стеаринова кислота овочевого походження, кремній.',
				},
				properties: ['є джерелом вітімінів, мінералів, ферментів, есенціальних жирних кислот, білків;',
					'підвищує фізичну активність та витривалість;',
					'оказує протимікробну дію;',
					'покращує травлення;',
					'підвищує природні сили організму;',
					'оказує протизапальну, протиатеросклеротичну, радіопротекторну, жовчогонну, сечогонну дію та стимулює функцію щитовидної залози;',
					'має ранозагоюючий ефект.',
				],
				application: ['для комплексного лікування захворювань печінки, нирок, виразки шлунку, дванадцятипалої кишки;',
					'синдром хронічної втоми;',
					'депресія;',
					'перелами;',
					'атеросклероз;',
					'простатит, аденома простати;',
					'неврози, порушення сну;',
					'подагра;',
					'пародонтоз;',
					'для підвищення м’язової сили;',
					'стимулювання розумової діяльності;',
					'покращення апетіту та нарощення маси тіла;',
					'особам, які відновлюються після інфекційних захворювань;',
					'коліти, хронічні закрепи.',
				],
				price: 12.28,
				way: 'по 2 капсули на день під час їжі. Зберігати у сухому, прохолодному, темному місті.',
				picture: require('@/assets/pollen1.webp'),
				picture2: require('@/assets/pollen2.webp'),
				picture3: require('@/assets/bee.png'),
			},
			{
				id: 31,
				qty: 1,
				bee: true,
				name: 'Now Foods, Країна виробник: США',
				title: 'Royal Jelly (Маточне молочко) 60 капсул',
				composition:
				{
					title: 'Склад 1 капсули:',
					name1: 'Calories (калорії)',
					name2: 'Royal Jelly (14 mg 10-HDA) (Freeze-dried concentrate  equivalent to 1000 mg of fresh Royal Jelly) (маточне молочко (14 мг концентрату сухої заморозки, еквівалент 1000 мг свіжого маточного молочка))',
					quantity: '5',
					quantity2: '303 мг',
					dp: '',
					dp1: '+',
					text2: '+Добова потреба не визначена',
					text3: 'Інші інгредієнти: желатинова капсула, олія висівок рису, бджолиний віск, соняшниковий лецитин, кремнію диоксид.',
				},
				properties: ['є джерелом есенціальних та харчових речовин;',
					'є високопоживним продуктом (містить білку у 5 разів більше ніж молоко корови, вуглеводів у 6 разів, жирів у 3 рази, вітамінів С, В1, В2, В6, В12, РР, Н та фолієвої кислоти у декілька разів);',
					'підвищує стійкість організму до інфекцій та дії несприятливих екологічних факторів;',
					'оказує тонізуючу та загальноукріплюючу дію на організм, підвищує фізичну та розумову працездатність;',
					'покращує обмін речовин, травлення, кровотворення, серцеву діяльність;',
					'регулює артеріальний тиск;',
					'оказує антибактеріальну, антипаразитарну та протимікробну дію;',
					'протистоїть неврозам та депресіям.',
				],
				application: ['виснаження організму;',
					'порушення обміну речовин, діабет, затримки процесів розвитку та росту;',
					'зниження статевої активності;',
					'підвищені розумові та фізичні навантаження;',
					'особам похилого віку;',
					'стреси, безсоння;',
					'первинні неврози;',
					'імунодефіцитні стани;',
					'анемії;',
					'захворювання шкіри;',
					'цироз печінки, хронічні гастрити, коліти;',
					'бронхіальна астма;',
					'первинні хронічні поліартрити;',
					'загальний атеросклероз;',
					'хронічна втома.',
				],
				price: 20.97,
				way: 'по 1 капсулі на день під час їжі. Зберігати у сухому, прохолодному, темному місті.',
				picture: require('@/assets/royal1.webp'),
				picture2: require('@/assets/royal2.webp'),
				picture3: require('@/assets/bee.png'),
			},
			{
				id: 32,
				qty: 1,
				bee: true,
				name: 'Now Foods, Країна виробник: США',
				title: 'Propolis (Прополіс) 100 капсул',
				composition:
				{
					title: 'Склад 1 капсули:',
					name1: 'Bee Propolis 5:1 Extract Powder (Equivalent to 1500 mg Bee Propolis) (порошок екстракту 5:1 бджолиного прополісу  (еквівалент 1500 мг бджолиного прополісу))',
					quantity: '303 мг',
					dp: '+',
					text2: '+Добова потреба не визначена',
					text3: 'Інші інгредієнти: целюлозна капсула, стеаринова кислота овочевого походження, магнію стеарат овочевого походження та кремнію диоксид.',
				},
				properties: ['оказує антибактеріальну та противірусну дію;',
					'є протизапальним засобом;',
					'знижує набряклість та пом’якшує ущільнення (затверділі тканини);',
					'має антибіотичні властивості;',
					'оказує протибольову дію;',
					'стимулює фагоцитоз та вироблення інтерферону, підвищує імунітет;',
					'стимулює загоєння поранень, ерозій, саднів;',
					'оказує протигрибкову дію;',
					'підвищує тонус та укріплює організм.',
				],
				application: ['грип;',
					'захворювання органів дихання бактеріальної та вірусної етіології;',
					'грибкові захворювання;',
					'синдром хронічної втоми;',
					'ентерити;',
					'виразки;',
					'гастрити;',
					'захворювання ротової порожнини, очей;',
					'лікування та профілактика захворювань простати, простатитів;',
					'герпес;',
					'оперізуючий лишай;',
					'ерозії шийки матки;',
					'захворювання ЛОР-органів (тонзиліти, гингивити та ін.);',
					'захворюваня шлунково-кишкового тракту;',
					'захворювання шкіри;',
					'вугровий висип.',
				],
				price: 15.27,
				way: 'по 1 капсулі на день. Зберігати у сухому, прохолодному, темному місті.',
				picture: require('@/assets/propolis2.webp'),
				picture2: require('@/assets/propolis1.webp'),
				picture3: require('@/assets/bee.png'),
			},
			{
				id: 33,
				qty: 1,
				name: 'Now Foods, Країна виробник: США',
				title: 'Глюкозамін, MСM та Арніка (Glucosamine, MSM & Arnica) 237 мл',
				composition:
				{
					title: 'Склад:',
					name1: 'вода',
					name2: 'сік листя Алое Вера',
					name3: 'МСМ (метилсульфонілметан)',
					name4: 'цетеариловий спирт',
					name5: 'глюкозамін сульфат (з молюсків)',
					name6: 'гліцерин',
					name7: 'олія солодкого мигдалю',
					name8: 'каприловий тригліцерид',
					name9: 'екстракт квітів арніки',
					name10: 'масло зерен сафлори',
					name11: 'стеаринова кислота овочевого походження',
					name12: 'цетеарет-20',
					name13: 'масло зерен лімнантесу',
					name14: 'токоферилу ацетат (вітамін Е з сої)',
					name15: 'фосфатидилхолін (фосфоліпіди з сої)',
					name16: 'екстракт листя зеленого чаю',
					name17: 'екстракт зерен грейпфруту',
					name18: 'природний хінокітіол',
					name19: 'ксантан',
					quantity: '',
					quantity2: '',
					quantity3: '',
					quantity4: '',
					quantity5: '',
					quantity6: '',
					quantity7: '',
					quantity8: '',
					quantity9: '',
					quantity10: '',
					quantity11: '',
					dp: '',
					dp1: '',
					dp2: '',
					dp3: '',
					dp4: '',
					dp5: '',
					dp6: '',
					dp7: '',
					dp8: '',
					dp9: '',
					dp10: '',
					text1: '*Не містить клейковини',
				},
				properties: ['оказує протизапальну та протибольову дію;',
					'покращує мікроциркуляцію у кровоносних судинах, зменшує набрякливість та відновлює функції сполучної тканини;',
					'відновлює суглобний хрящ та колаген;',
					'оказує поживну підтримку суглобам, попереку, сполучної тканині;',
					'оказує протиревматичну, седативну та діуретичну дію;',
					'протидіє місцевим алергійним реакціям;',
					'має репаративну дію.',
				],
				application: ['запалювальні та обмінні захворювання суглобів (артрози, артрити);',
					'остеохондроз попереку з радикулярним синдромом;',
					'больовий синдром різноманітного генезу без ураження шкірних покривів (міозіти, невралгії, судинні болі).',
				],
				price: 17.85,
				way: 'втирати у шкіру за мірою необхідності',
				picture: require('@/assets/gluk.webp'),
				picture2: require('@/assets/gluk_1.webp'),
			},
			{
				id: 34,
				qty: 1,
				name: 'Now Foods, Країна виробник: США',
				title: 'Liquid Chlorophyll (Хлорофіл рідкий) 473 мл',
				composition:
				{
					title: 'СКЛАД 1 ч.л. (5 мл):',
					name1: 'Calories (калорії)',
					name2: 'Total Carbohydrate (вуглеводи)',
					name3: 'Copper (From Sodim Copper Chlorophyllin)(мідь (натрієво-мідний хлорофілін))',
					name4: 'Sodium (From Sodim Copper Chlorophyllin)(натрій (натрієво-мідний хлорофілін))',
					name5: 'Sodim Copper Chlorophyllin (Chlorophyll) (натрієво-мідний хлорофілін) (хлорофіл)	)',
					quantity: 15,
					quantity2: '4г',
					quantity3: '4мг ',
					quantity4: '10мг ',
					quantity5: '100мг ',
					dp: '',
					dp1: '1%*',
					dp2: 444,
					dp3: '<1%',
					dp4: '+',
					text1: '*Добова потреба розрахована на дієту у 2000 калорій',
					text2: '+Добова потреба не визначена',
					text3: 'Інші інгредієнти: овочевий гліцерин, деіонізована вода, масло м’яти перцевої, сорбат калію (як консервант).',
				},
				properties: ['посилює імунну функцію організму, прискорює фагоцитоз, сприяє виробленню інтерферону;',
					'оказує протизапальну та антибактеріальну дію;',
					'запобігає росту бактерій у ранах, анаеробних бактерій та грибків у кишківнику;',
					'очищує кров, виводить токсіни, підтримує корисну кишкову флору;',
					'має дезодоруючі якості;',
					'прискорює азотний обмін;',
					'регулює артеріальний тиск, укріплює клітинні мембрани, сприяє формуванню з’єднувальної тканини;',
					'загоює рани, виразки, ерозії;',
					'усуває анемію;',
					'активізує дію ферментів, які беруть участь у синтезі вітамінів А,Е та К;',
					'запобігає розвитку каменів у нирках;',
					'нормалізує функцію щитовидної та підшлункової залози;',
					'посилює роботу кишківника;',
					'оказує посилений сечогінний ефект;',
					'знижує нервозність;',
					'запобігає виникненню карієсу та пошкодженню ясен;',
					'запобігає розвитку артритів;',
					'підвищує опірність організму.',
				],
				application: ['простудні захворювання;',
					'ЛОР-захворювання;',
					'гингивіти, карієс, пародонтоз;',
					'грибкові захворювання;',
					'рани, ерозії, виразки, дерматити;',
					'виразкова хвороба шлунку та дванадцятипалої кишки, коліт;',
					'програма детоксікації;',
					'дисбактеріоз;',
					'анемії;',
					'радіаційні ураження;',
					'артрити;',
					'програма омолодження організму;',
					'трихомонадний кольпіт (спринцювання);',
					'захворювання носоглотки (полоскання).',
				],
				price: 22.89,
				way: 'по 1 ч.л.(5 мл) на стакан води 1-2 рази на день. Зберігати у сухому, прохолодному, темному місті.',
				picture: require('@/assets/chlorophyll_2.webp'),
				picture2: require('@/assets/chlorophyll.webp'),
			},
			{
				id: 35,
				qty: 1,
				name: 'Now Foods, Країна виробник: США',
				title: 'Lecithin Granules (Лецитин у гранулах) 454 г',
				composition:
				{
					title: 'Склад 1,5 ст.л. (10 г):',
					// space1: true,
					// farm: true,
					name1: 'Calories (калорії)',
					name2: 'Total Fat (жири):',
					name3: 'Saturated Fat (насичені жири) ',
					name4: 'Polyunsaturated Fat (поліненасичені жири)',
					name5: 'Monounsaturated Fat (мононенасичені жири)',
					name6: 'Sodium (натрій)',
					name7: 'Total Carbohydrate (вуглеводи)',
					name8: 'Protein (білок)',
					name9: 'Calcium (кальцій)',
					name10: 'Iron (залізо)',
					name11: 'Potassium (калій)',
					name12: 'Phosphorus (фосфор)',
					quantity: 70,
					quantity2: '5г',
					quantity3: '1,5г',
					quantity4: '3,5г',
					quantity5: '0.5г',
					quantity6: '0мг',
					quantity7: '1г',
					quantity8: '0г',
					quantity9: '14мг',
					quantity10: '0,4мг',
					quantity11: '160мг',
					quantity12: '300мг',
					dp: ' ',
					dp1: '6*',
					dp2: '8*',
					dp3: '+',
					dp4: '+',
					dp5: '0',
					dp6: '<1',
					dp7: ' ',
					dp8: '2',
					dp9: '2',
					dp10: '4',
					dp11: '25',
					text1: '*Добова потреба розрахована на дієту у 2000 калорій',
					text2: '+Добова потреба не визначена',
				},
				properties: ['є основною живильною речовиною для нервів, яка складає 17% переферічної нервової системи та 30% мозку, входить до складу оболонок нервових волокон;',
					'активізує пам’ять, аналітичні функції мислення;',
					'бере участь у нормальному розвитку мозку та нервової системи плоду;',
					'регулює проникність кліткових мембран, бере участь у синтезі білку та у регуляції обміну речовин;',
					'покращує структуру та роботу клітин печінки (гепатоцитів);',
					'знижує рівень холестерину та коцентрацію жирних кислот у крові;',
					'очищує стінки судин від холестеринових бляшок;',
					'усуває розлади, які пов’язані з гормональними процесами в организмі;',
					'гальмує жирову інфільтрацію печінки.',
				],
				application: ['функціональні порушення нервової та психічної деяльності;',
					'розсіяна увага та зниження пам’яті;',
					'хронічна втома, нервове виснаження;',
					'травматичні та інфекціонні захворювання нервової системи;',
					'дегенеративні захворювання нервової системи (енцефалопатії);',
					'неврози, депресія;',
					'розсіяний склероз;',
					'хвороба Альцгеймера;',
					'хронічний алкоголізм, алкогольні поліневрити;',
					'різноманітні фобії;',
					'атеросклероз, гіпертонічна хвороба, стенокардія;',
					'захворювання печінки та жовчовивідної системи (вірусний гепатіт, хронічний гепатіт, дискінезія жовчовиводних шляхів, алкогольні та токсичні гепатіти, жирова дістрофія печінки, цироз печінки);',
					'псоріаз.',
				],
				price: 21.85,
				way: 'По 1,5 ст.л. на день, бажано під час їжі. Можливо змішати з соком або коктейлем, а також додати в їжу. Зберігати у сухому, прохолодному, темному місті.',
				picture: require('@/assets/granules.webp'),
				picture2: require('@/assets/granules_1.webp'),
			},
		],
		filter: {},
		cart: JSON.parse(localStorage.getItem('cart')) || [],
	},
	getters: {
		getProductsList: (state) => state.productsList,
		getGuaranteeList: state => state.guarantee,
		getCart: (state) => state.cart,
		// getProductById: state => productId => state.productsList.find(product => productId == product.id),
		getProductById: state => productId => {
			return state.productsList.find(product => product.id === parseInt(productId));
		},
		getFilteredList: (state) => state.productsList.filter((product) => isMatchFilter(product, state.filter)),
		getPrices: (state) => state.prices,
	},
	mutations: {
		removeFromCartAll(state) {
			state.cart = []
		},
		setFilter(state, filterData) {
			state.filter = filterData
		},
		addToCart(state, productId) {
			if (!state.cart.includes(productId)) {
				state.cart.push(productId);
				localStorage.setItem('cart', JSON.stringify(state.cart));
			}
		},
		removeFromCart(state, productId) {
			const index = state.cart.indexOf(productId);
			if (index !== -1) {
				state.cart.splice(index, 1);
				localStorage.setItem('cart', JSON.stringify(state.cart));
			}
		},
		loadCartFromLocalStorage(state) {
			const savedCart = JSON.parse(localStorage.getItem('cart'));
			if (savedCart) {
				state.cart = savedCart;
			}
		},
	},
	actions: {
		updateremoveFromCartAll({ commit }) {
			commit('removeFromCartAll')
		},
		updateremoveFromCart({ commit }, productId) {
			commit('removeFromCart', productId)
		},
		updateloadCartFromLocalStorage({ commit }) {
			commit('loadCartFromLocalStorage')
		},
		updateFilter({ commit }, filterData) {
			commit('setFilter', filterData)
		},
		updateCart({ commit }, productId) {
			commit('addToCart', productId)
		},
	},
	modules: {},
});